// ── i18n ──
const LOCALES = {
  ja: {
    // auth
    'login': 'ログイン',
    'loggingIn': 'ログイン中...',
    'loginRequired': 'ログインが必要です',
    'logout': 'ログアウト',
    'email': 'メールアドレス',
    'password': 'パスワード',
    'emailPasswordRequired': 'メールアドレスとパスワードを入力してください',
    'forgotPassword': 'パスワードをお忘れですか？',
    'noAccount': 'アカウントをお持ちでない場合は',
    'signupLink': '新規登録はこちら',
    'oauthLoginBtn': 'Googleでログイン',
    // capture
    'captureBtn': 'キャプチャして作成',
    'capturing': 'キャプチャ中...',
    'captureFailed': 'キャプチャ失敗: {msg}',
    'analyzing': '解析中...',
    'hint2040sec': '20〜40秒ほどかかります',
    'pasteFromClipboard': 'クリップボードから貼り付け',
    'uploadImage': '画像をアップロード',
    'createFromText': 'テキストから作成',
    'analyzingQueue1': 'スクリーンショットを解析中...',
    'analyzingQueueN': '{done}/{total}件を解析中...',
    'memoPlaceholder': '補足メモ（任意）：日付・文脈・依頼者など',
    'deadlineOptional': '期日（任意）',
    'submit': '作成',
    'skip': 'スキップ',
    'cancel': 'キャンセル',
    'textPlaceholder': 'テキストを入力または貼り付け...',
    // tabs / filters
    'tabToday': '今日',
    'tabReview': 'レビュー',
    'tabAll': 'すべて',
    'tabDone': '完了',
    'appRailGoals': 'ゴール',
    'nothingDueToday': '今日までのものはありません',
    'nothingDueTodayHint': '期限が先のものは「すべて」にあります',
    'tabCreate': '+ 作成',
    'appRailLabel': 'メインメニュー',
    'appRailCreate': '作成',
    'appRailAccount': 'アカウント',
    'sectionOverdue': '期限切れ',
    'sectionToday': '今日',
    'sectionTomorrow': '明日',
    'sectionThisWeek': '今週',
    'sectionFuture': 'それ以降',
    'sectionNone': '期限なし',
    'sectionSchedule': '予定',
    // empty states
    'noTasksToday': 'いま対応することはありません',
    'noTasksAll': 'ゴールはまだありません',
    'noTasksHint': 'スクリーンショットをキャプチャするか、テキストを貼り付けてゴールを作成しましょう',
    'noTasksFiltered': '該当するゴールはありません',
    'allGoalsDone': 'すべてのゴールを完了しました！',
    'allGoalsDoneHint': '新しいゴールを作成するか、Claudeから同期しましょう',
    'noReviewTasks': 'レビュー待ちのゴールはありません',
    'emptyStateTitle': 'はじめましょう',
    'emptyStateSubtitle': 'ゴールを作成する3つの方法',
    'emptySyncTitle': 'Claude Desktopから同期',
    'emptySyncDesc': 'Gmail・Slack・Calendarからゴールを自動作成',
    'emptySyncStep1': 'Claude Desktopアプリを開く',
    'emptySyncStep2': '「同期して」と入力する',
    'emptySyncStep3': 'Gmail・Slack・Calendarからゴールが自動作成されます',
    'emptySyncSetupLink': '初めての方はセットアップガイドを確認',
    'emptyScreenshotTitle': 'Chrome拡張で作成',
    'emptyScreenshotDesc': 'サイドパネルからスクショを撮ってAIがゴールを自動抽出',
    'emptyTextTitle': 'テキストから作成',
    'emptyTextDesc': 'テキストを貼り付けてゴールを作成',
    // subtasks
    'addSubtask': 'タスク追加',
    'addSubtaskOrFeedback': 'タスク追加 or 調整を依頼',
    'feedbackRecorded': 'ゴールに記録しました',
    'done': '完了',
    'retry': 'やり直し',
    'approve': '承認',
    'rejectFeedbackPlaceholder': 'フィードバック（任意）：どこを修正してほしいか',
    'rejectConfirm': 'やり直す',
    'reviewing': 'レビュー',
    'executing': '実行中',
    'pending': '待機中',
    'inProgress': '進行中',
    'subtaskGenerating': 'タスク生成中...',
    'noSubtasks': 'タスクはありません',
    // goal actions
    'delete': '削除',
    'save': '保存',
    'edit': '編集',
    'confirmDelete': '「{title}」を削除しますか？',
    'confirmDeleteGoal': '「{title}」を削除しますか？削除から元に戻すことはできませんが、よろしいですか？',
    // #1929 S4: the review's completion candidate after a task is done
    'completionSuggestedMsg': '「{title}」は完了の条件を満たしたようです。完了にしますか？',
    'completionSuggestedAction': '完了にする',
    'completionSuggestedDone': 'ゴールを完了にしました。',
    'goalDeleted': 'ゴールを削除しました',
    'goalDeleteFailed': '削除に失敗しました',
    // deadline
    'today': '今日',
    'tomorrow': '明日',
    'noDeadline': '期限なし',
    'setDeadline': '期限を設定',
    // priority
    'priorityHigh': '高',
    'priorityMedium': '中',
    'priorityLow': '低',
    'priorityNone': '-',
    'setPriority': '優先度設定',
    'prioritySet': '優先度を「{p}」に設定しました',
    // messages / toasts
    'goalsCreated': '{count}件のゴールを作成しました',
    'goalCreated1': 'ゴールを作成しました',
    'shiftedDays': '{count}日後に変更しました',
    'copied': 'コピーしました',
    'saved': '保存しました',
    'profileSaved': 'プロフィールを保存しました',
    // errors
    'errorNetwork': 'サーバーに接続できません。ネットワーク接続を確認してください。',
    'errorServer': 'サーバーが一時的に利用できません。しばらくしてから再度お試しください。',
    'errorTimeout': 'サーバーの応答がタイムアウトしました。しばらくしてから再度お試しください。',
    'errorTooMany': 'リクエストが多すぎます。しばらくしてから再度お試しください。',
    'errorGeneral': 'エラーが発生しました',
    'errorServerGeneral': 'サーバーエラーが発生しました。しばらくしてから再度お試しください。',
    'clipboardFailed': 'クリップボードからの読み取りに失敗しました',
    'clipboardWriteFailed': 'クリップボードにコピーできませんでした',
    'clipboardNoImage': 'クリップボードに画像がありません',
    'textEmpty': 'テキストを入力してください',
    'analysisFailed': '解析に失敗しました',
    // profile
    'profileDisplayName': '表示名',
    'profileDisplayNamePlaceholder': 'Hanako Sato',
    'profileDisplayNameHint': 'ワークスペースのメンバーに表示されます',
    'profileEmail': 'メールアドレス',
    'profileEmailUnavailable': 'メールアドレス未取得',
    'profileName': 'あなたを指す名前',
    'profileNameHint': 'スクショや連携データ内の名前から、依頼者・実行者の判定に使います',
    'profileNamePlaceholder': '田中太郎, たなか, Tanaka（カンマ区切り）',
    'profileRole': '役割',
    'profileRolePlaceholder': '例：プロダクトマネージャー、エンジニア',
    'profileLocation': '拠点1',
    'profileLocationPlaceholder': '例：渋谷駅、六本木オフィス',
    'profileLocationHint': '対面予定の移動時間を推定するために使います',
    'profileLocation2': '拠点2',
    'profileLocation2Placeholder': '例：二子玉川駅（なければ空欄）',
    'profileWeekdayDaytimeLocation': '平日の日中に出発する拠点',
    'profileWeekdayDaytimeLocationHint': '平日の9時〜19時に始まる予定はこの拠点から、それ以外はもう一方の拠点から移動すると考えます。同じ日の直前に場所のある予定があれば、その場所から出発します。',
    'profileInterests': '関心のあるテーマ',
    'profileInterestsPlaceholder': '例：AI, デザイン, 投資（カンマ区切り）',
    'profileGoals': '現在の目標',
    'profileGoalsPlaceholder': '例：MVP完成, 英語力向上（カンマ区切り）',
    'profileBioPlaceholder': 'タスク分解やコミュニケーションに関するその他の指示（任意）',
    'profileTimezone': 'タイムゾーン',
    'profileTimezoneHint': '期日の判定に使用します（ブラウザから自動検出）',
    'profileLanguage': '言語',
    'profileLanguageHint': 'Zenmetry の画面表示と言語に依存する説明文に使います。AI の下書き文体は別の文体設定も参照します。',
    'profileSaveBtn': '保存',
    'profileTitle': 'プロフィール設定',
    'profileAIPref': 'AIの動作設定',
    'profileAdvancedSettings': '詳細設定',
    'profileWhereHint': 'AI がゴール化するか、誰の仕事として扱うか、どのサービスで下書き・実行するかを判断するための前提です。',
    'profileWhereAccounting': '会計',
    'accTaskPayments': '入金・支払い',
    'accTaskInvoices': '請求書発行',
    'accTaskExpenses': '経費精算',
    'accExecUnset': '（未設定）',
    'accExecSelf': '自分が実行',
    'accExecDelegate': '他の人が実行',
    'accExecNone': '実行しない',
    'accExecDelegatePreserved': '以前の設定: 他の人が実行',
    'accExecPreserved': '以前の設定を保持: {value}',
    'accSystemLabel': '使用ソフト',
    'accTaxReview': '税理士による最終チェックあり',
    'profileWhereMail': 'メール送信に使うサービス',
    'profileWhereSchedule': '予定作成に使うサービス',
    'profileWhereUnset': '未設定',
    'profileWhereOther': 'その他',
    'profileWherePaper': '紙・手帳',
    'prefCommExternal': '社外メール・外部連絡',
    'prefCommFormal': '丁寧な敬語',
    'prefCommBusinessCasual': 'ビジネスカジュアル',
    'prefCommAuto': '相手に合わせる',
    'prefCommInternal': '社内Slack・内部連絡',
    'prefCommCasual': 'カジュアル',
    'prefCommFormal2': '丁寧に',
    'prefCommAuto2': '相手に合わせる',
    'prefCommFallbackHint': '文体プロファイルを学習できないメッセージ系サービス向けのフォールバックです。',
    'prefTaskGranularity': 'タスク分解の粒度',
    'prefTaskFine': '細かく（5〜15分）',
    'prefTaskNormal': '普通',
    'prefTaskCoarse': '大まかに（30分以上）',
    'prefTaskGranularityHint': '必要な場合だけ変更してください。通常は「普通」で十分です。',
    'prefNoReminder': 'リマインダーのタスクを自動生成しない',
    'prefAddTravel': '対面予定には移動時間のタスクを追加する',
    'prefTravelMode': '移動手段',
    'prefTravelModeHint': '拠点と合わせて、対面予定の移動時間見積もりに使います。',
    'prefTravelTrain': '電車',
    'prefTravelCar': '車',
    'prefTravelPlane': '飛行機',
    'prefTravelUndecided': '未定',
    'prefMeetingDefaultAttendance': '会議参加の既定',
    'prefMeetingDefaultAttendanceHint': '対面・オンラインの両方が可能なときのおすすめに使います。',
    'prefMeetingDefaultAttendanceAuto': '状況に応じて判断',
    'prefMeetingDefaultAttendanceInPerson': '基本は対面',
    'prefMeetingDefaultAttendanceOnline': '基本はオンライン',
    'prefEventDefaultAttendance': 'イベント参加の既定',
    'prefEventDefaultAttendanceHint': 'セミナーやカンファレンスで現地参加を優先するかの目安に使います。',
    'prefEventDefaultAttendanceAuto': '状況に応じて判断',
    'prefEventDefaultAttendanceInPerson': '基本は現地参加',
    'prefEventDefaultAttendanceOnline': '基本はオンライン参加',
    'prefUnreadDeadline': '期限が書かれていないときの期限',
    'prefUnreadDeadlineHint': 'メールやスクショに期限が書かれていないゴールに、仮の期限として使います。ゴールを作った日から数え、土日は営業日に数えません。仮の期限は朝の確認で確かめます。',
    'prefUnreadDeadlineSameDay': '当日',
    'prefUnreadDeadlineNextBusinessDay': '翌営業日',
    'prefTravelWalk': '徒歩',
    'prefTravelBike': '自転車',
    'aiWorkVerb_read': '読む・調べる',
    'aiWorkVerb_draft': '下書き',
    'aiWorkVerb_send': '送る',
    'aiWorkVerb_schedule': '予定を入れる',
    'aiWorkVerb_respond_invite': '予定に返事',
    'aiWorkVerb_make': '作る（資料・請求書など）',
    'aiWorkVerb_register': '登録する',
    'aiWorkVerb_apply': '申請する',
    'aiWorkVerb_update': '直す',
    'aiWorkVerb_organize': '整理する（ラベル・移動・アップロード）',
    'aiWorkVerb_delete': '消す',
    'aiWorkVerb_approve': '承認する（他の人の申請）',
    'aiWorkVerb_site_procedure': 'サイトで手続き',
    'aiWorkVerb_pay': '支払い',
    'settingsNavAiWork': 'AIに任せる業務',
    'aiWorkCardsDesc': '業務の段取りごとに、AIにお任せになるか、承認してからAIにさせるか、ご自身でなさるかを決められます。カードを開いて、段取り・使うサービス・この業務の好み・AIごとの道具をお選びください。選んだ内容はすぐに保存されます。',
    'aiWorkStateAuto': 'AIが自動で',
    'aiWorkStateCheck': '承認してからAI',
    'aiWorkStatePrincipal': 'ご自身で（AIにさせない）',
    'aiWorkStepAria': '{step}：{state}',
    'aiWorkStepMixed': 'サービスによって設定が違います。選ぶと、この業務のサービスすべてにそろえます。',
    'aiWorkSaveFailed': '保存できませんでした。もう一度お試しください。',
    'aiWorkStepFixed': '支払いは、AI に任せるときも必ず承認をはさみます。',
    'aiWorkStateShortAuto': 'AIが自動で',
    'aiWorkStateShortCheck': '承認してから',
    'aiWorkStateShortPrincipal': 'ご自身で',
    'aiWorkOpenCard': '{name}の詳細',
    'aiWorkAisCan': '{names} ができます',
    'aiWorkNoAiYet': 'まだどのAIもできると申告していません',
    'aiWorkNoServiceYet': '使うサービスはまだ決まっていません',
    'aiWorkAddCard': '業務を追加',
    'aiWorkAddCardName': '業務の名前',
    'aiWorkAddCardNamePlaceholder': '契約書',
    'aiWorkAddCardSteps': '含まれる段取り',
    'aiWorkAddCardSubmit': '追加',
    'aiWorkRemoveCard': 'この業務を外す',
    'aiWorkBreadcrumb': '現在の場所',
    'aiWorkSteps': '段取り',
    'aiWorkServices': '使うサービス',
    'aiWorkSites': '手続きするサイト',
    'aiWorkViaBrowser': '{service}（ブラウザで）',
    'aiWorkSiteAdd': 'サイトを追加',
    'aiWorkSitesPlaceholder': 'e-tax, e-gov',
    'aiWorkSitesHint': 'AI はブラウザでサイトを操作します。サイトごとに任せ方を変えたいときだけ、そのサイトを追加してください。',
    'aiWorkServicesHint': 'この業務でいつも使うサービスです。AI はこのサービスで作業します（専用の道具がなければブラウザで）。複数お使いなら、すべて追加してください。',
    'aiWorkServiceAdd': 'サービスを追加',
    'aiWorkServiceRemove': '{service}を外す',
    'aiWorkPrefs': 'この業務の好み',
    'aiWorkPrefWho': 'どなたがなさいますか',
    'aiWorkPrefWhoUnset': 'まだ決めていない',
    'aiWorkPrefWhoSelf': 'ご自身で',
    'aiWorkPrefWhoDelegate': '担当者に任せる',
    'aiWorkPrefWhoNone': 'この業務はない',
    'aiWorkPrefWhoHint': '「担当者に任せる」なら、AI はこの業務を誰かに依頼するものとして扱います。「この業務はない」なら対象外として扱います。',
    'aiWorkTools': 'AIごとの道具',
    'aiWorkToolsHint': 'つながっている AI が申告した道具です。道具ごとに決めた内容は、AI が申告し直しても残ります。',
    'aiWorkToolsLoading': 'AI の申告を読み込んでいます',
    'aiWorkToolsError': 'AI の申告を読み込めませんでした。時間をおいて開き直してください。',
    'aiWorkToolsNeedService': '使うサービスを追加すると、そのサービスで AI が使える道具がここに出ます。',
    'aiWorkToolsNone': 'この業務のサービスで使える道具を申告した AI は、まだありません。',
    'aiWorkLastDeclared': '最終確認 {date}（{name}）',
    'aiWorkBulk': 'まとめて',
    'aiWorkBulkAria': '{service}の道具をまとめて',
    'aiWorkToolReset': '元に戻す',
    'aiWorkToolLabel': '{step}（{action}）',
    'aiWorkToolAction_create': '新規作成',
    'aiWorkToolAction_update': '更新',
    'aiWorkToolAction_delete': '削除',
    'aiWorkToolAction_reply': '返信',
    'aiWorkToolAction_forward': '転送',
    'aiWorkToolAction_search': '検索',
    'aiWorkToolAction_get': '1件を開く',
    'workCard_mail': 'メールの返信',
    'workCard_schedule': '日程調整',
    'workCard_chat': '社内の連絡',
    'workCard_search': '資料を探す',
    'workCard_quote': '見積書',
    'workCard_invoice': '請求書',
    'workCard_expense': '経費精算',
    'workCard_approval': '申請の承認',
    'workCard_payment': '支払い',
    'workCard_files': 'ファイルの整理',
    'workCard_site': 'Webサイトでの手続き',
    'workStep_mail_read': '読む',
    'workStep_mail_draft': '下書き',
    'workStep_mail_send': '送る',
    'workStep_schedule_read': '空きを調べる',
    'workStep_schedule_send': '候補を送る',
    'workStep_schedule_schedule': '予定を入れる',
    'workStep_schedule_respond': '招待に返事',
    'workStep_chat_read': '読む',
    'workStep_chat_draft': '下書き',
    'workStep_chat_send': '送る',
    'workStep_search_read': '探す',
    'workStep_search_make': 'まとめる',
    'workStep_doc_make': '作る',
    'workStep_doc_send': '送る',
    'workStep_expense_apply': '申請する',
    'workStep_approval_read': '内容を確かめる',
    'workStep_approval_approve': '承認する',
    'workStep_payment_pay': '支払う',
    'workStep_files_organize': '整理する',
    'workStep_files_delete': '消す',
    'workStep_site_procedure': '手続きする',
    'prefOtherBio': 'その他の補足（任意）',
    // dates (for dynamic rendering)
    'weekdays': ['日', '月', '火', '水', '木', '金', '土'],
    // goal done / priority titles
    'goalDoneUndo': '未完了に戻す',
    'goalDoneSet': '完了にする',
    'goalCompleted': 'ゴールを完了しました',
    'goalUncompleted': '未完了に戻しました',
    // subtask counter / actions
    'tasksLabel': 'タスク',
    'subtaskCompleted': '完了しました',
    'titleUpdated': 'タイトルを更新しました',
    'dodUpdated': '完了の定義を更新しました',
    'dodLabel': '完了基準',
    'dodAdd': '追加...',
    'dodDriftMsg': 'タスクが変わりました。クリックして完了基準を見直してください',
    // bulk selection
    // decision
    'decisionConfirm': '「{label}」に決定しますか？',
    'decisionSuccess': '決定しました',
    'decisionNext': '次',
    'followupGoalConfirm': '「{title}」ゴールを作成しますか？',
    'followupGoalCreated': '応募ゴールを作成しました',
    'followupGoalCreateError': 'フォローアップゴール作成に失敗しました: {msg}',
    'decisionResetDone': '判断をリセットしました',
    'freeDecisionRequired': '選択内容を入力してください',
    // calendar events
    'allDay': '終日',
    'markDoneTitle': '完了にする',
    'markUndoneTitle': '完了を取り消す',
    'completedItems': '完了済み {n}件',
    // ask AI
    'copyClaudeMobile': 'コピーしました！Claudeアプリを開いて貼り付けてください',
    'copyClaudeDesktop': 'コピーしました！Claudeを開きます',
    'askAISubtask': 'AIと相談',
    // date picker
    'monthNames': ['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月'],
    'subtaskDeadlineHint': '今日以降の日付を設定',
    // error messages
    'updateError': '更新エラー: {msg}',
    'deadlineSetError': '期日設定エラー: {msg}',
    'completionError': '完了設定エラー: {msg}',
    'dodError': 'DoD更新エラー: {msg}',
    'decisionError': '決定エラー: {msg}',
    'decisionResetError': 'リセットエラー: {msg}',
    'deadlineUpdated': '期日を更新しました',
    'deadlineUpdateError': '期日更新エラー: {msg}',
    // #2489: Goal edits refused with 409, keyed by the server's code
    'goalUpdateConflictJudgment': 'このゴールには判断が含まれているため、完了条件・期限・開始日などの変更は保存できませんでした。タイトルと優先度は変更できます。',
    'goalUpdateConflictPending': 'このゴールは別の変更を反映している途中のため、保存できませんでした。数分待ってからもう一度お試しください。',
    'goalUpdateConflictDone': '完了したゴールのため、完了条件・期限・開始日などの変更は保存できませんでした。変更するには、先にゴールを未完了に戻してください。',
    'goalUpdateConflictNotActive': 'このゴールは今の状態では内容を変更できないため、保存できませんでした。',
    'goalUpdateConflictPartial': '変更の一部しか反映できませんでした。画面を再読み込みして内容を確かめ、必要ならもう一度お試しください。',
    'goalUpdateConflictGeneric': 'ほかの処理と重なったため保存できませんでした。もう一度お試しください。',
    'goalUpdateConflictJudgmentRow': '日時の選択に関わる完了基準は、ここでは書き換えも削除もできません。ほかの行は変更できます。',
    'goalUpdateConflictJudgmentHold': 'この判断には選んだ答えがあります。保留にしてから直してください。',
    'goalUpdateConflictDodRows': 'このゴールの完了基準は、行ごとに編集してください。画面を読み込み直してからお試しください。',
    'goalUpdateConflictCompatWrite': 'このゴールの完了基準は、完了基準の行の編集から変更してください。',
    'goalUpdateConflictDodLastRow': '完了基準をすべて消すことはできません。少なくとも1行を残してください。',
    'goalUpdateConflictProposalStale': 'AI の見立てが新しくなりました。表示を更新してから、もう一度確かめてください。',
    'reviewProposalKeep': '今のまま進める',
    'reviewProposalKept': '今のまま進めます。相手から新しいご連絡が来るまで、このご確認はいたしません。',
    'reviewProposalWithdraw': '外す',
    'reviewProposalWithdrawn': '完了基準を外しました。',
    'reviewProposalAddHint': '加えるときは、完了基準に行を書き足してください。',
    'reviewProposalAdd': 'この文で加える',
    'reviewProposalAdded': '完了基準を加えました。',
    'reviewProposalRewrite': 'この文に書き換える',
    'reviewProposalRewritten': '完了基準を書き換えました。',
    'reviewProposalRewriteHint': '書き換えるときは、完了基準の行を書き直してください。',
    'reviewProposalDraftHint': '文が違うときは、完了基準の行を書き直してください。',
    'dodRowsAdd': '行を追加',
    'dodRowsDelete': 'この行を削除',
    'dodRowsSave': '保存',
    'dodRowsCancel': 'キャンセル',
    'dodRowsJudgmentLocked': '日時の選択に関わる行は、ここでは変更できません。',
    'dodRowsJudgmentHint': '判断の行を消すと、その判断と選択肢の行も消えます。選んだ答えがある判断は、保留にしてから直します。',
    'dodRowsHoldConfirm': 'この判断には選んだ答えがあります。保留にして直しますか。直したあと、もう一度選んでください。',
    'dodRowsHoldConfirmAction': '保留にして直す',
    'deleteError': '削除エラー: {msg}',
    'approveError': '承認エラー: {msg}',
    'rejectError': '却下エラー: {msg}',
    // profile
    'loginStatus': 'ログイン中: {email}',
    'displayNameRequired': '表示名を入力してください',
    'onboardingNextBtn': '次へ',
    // goal deadline shift
    'subtaskAfterGoalDeadline': 'ゴールの期限より後の期限です',
    // subtask deadline moved
    'subtaskMovedToFilter': '「{label}」に移動しました',
    'showAction': '表示',
    // misc
    'langToggleLabel': 'EN',
    'backBtn': '戻る',
    'openInNewTab': '新しいタブで開く',
    // filters
    'filterLabelDeadline': '期日',
    'filterLabelStatus': '状態',
    'filterAll': 'すべて',
    'filterToday': '今日',
    'filterTomorrow': '明日',
    'filterThisWeek': '今週',
    'filterThisMonth': '今月',
    'filterOverdue': '期限切れ',
    'filterNone': '期日なし',
    'filterActive': '進行中',
    'filterReview': 'レビュー待ち',
    'filterDone': '完了',
    'loadMoreDone': 'さらに表示',
    // create panel
    'inputModeScreenshot': 'スクショ',
    'inputModeText': 'テキスト',
    'dropZoneText': 'スクリーンショットをドラッグ＆ドロップ',
    'dropZoneHint': 'クリックで選択（複数可）/ Ctrl+V でペーストも可',
    'textAnalyzeBtn': 'AIでタスク生成',
    'textTaskPlaceholder': 'ゴールの内容を入力してください\n\n例:\n・来週月曜に田中さんとミーティング\n・金曜までに企画書を提出\n・3月末までにプレゼン資料を完成させる',
    'createFabTitle': 'ゴールを作成',
    // signup form
    'pwHintLength': '12文字以上',
    'pwHintMatch': 'パスワードが一致',
    'agreeTermsPrefix': '',
    'agreeTermsLink': '利用規約',
    'agreeTermsAnd': ' および ',
    'agreePrivacyLink': 'プライバシーポリシー',
    'agreeTermsSuffix': ' に同意します',
    'signupValidationTerms': '利用規約とプライバシーポリシーへの同意が必要です',
    'signupTab': '新規登録',
    'signupBtn': 'アカウント作成',
    'signupName': 'お名前',
    'signupNamePlaceholder': '田中 太郎',
    'signupPasswordPlaceholder': '12文字以上',
    'resetDescription': '登録済みのメールアドレスを入力してください。パスワードリセット用のリンクをお送りします。',
    'search': '検索',
    'searchPlaceholder': 'ゴールを検索...',
    'searchHint': '検索キーワードを入力してください',
    'searchEmptyMsg': '「{query}」に一致するゴールはありません',
    'searchResultsCount': '{count}件ヒット',
    'closeLabel': '閉じる',
    'resetBtn': 'リセットメールを送信',
    'resetEmailSentTo': '{email} が登録済みなら、パスワード再設定のメールを送りました。届かないときは迷惑メールのフォルダをご確認のうえ、5分ほどたってから送り直してください。',
    'resetLinkInvalid': 'リンクが無効か期限切れです。もう一度リセットを依頼してください。',
    'resetLinkUnverified': 'リンクを確認できませんでした。時間をおいて、もう一度リセットを依頼してください。',
    'authInviteNotice': 'ワークスペースへの招待を受けるには、招待されたメールアドレスでログインまたは新規登録してください。',
    // invitation accept screen (#2432)
    'inviteAcceptTitle': 'ワークスペースへの招待',
    'inviteAcceptLoading': '招待を確認しています…',
    'inviteAcceptSubmitting': '参加しています…',
    'inviteAcceptSummary': '{inviter} さんが「{workspace}」に {role} として招待しています',
    'inviteAcceptSummaryNoInviter': '「{workspace}」に {role} として招待されています',
    'inviteAcceptWorkspaceFallback': 'ワークスペース',
    'inviteAcceptExistingData': '今のあなたのワークスペースには、ゴール {goals} 件と予定 {events} 件があります。参加するときの扱いを選んでください。',
    'inviteAcceptModeLabel': '既存データの扱い',
    'inviteAcceptModeMigrate': '新しいワークスペースへ移す',
    'inviteAcceptModeMigrateDesc': 'ゴールと予定を「{workspace}」に引き継ぎます',
    'inviteAcceptModeDelete': '削除して参加する',
    'inviteAcceptModeDeleteDesc': '今のゴールと予定を消してから参加します。元に戻せません',
    'inviteAcceptEmpty': '今のあなたのワークスペースは空なので、そのまま参加します。',
    'inviteAcceptSubmitBtn': '参加する',
    'inviteAcceptCancelBtn': 'キャンセル',
    'inviteAcceptDeleteConfirm': 'ゴール {goals} 件と予定 {events} 件を削除して参加します。元に戻せません。よろしいですか？',
    'inviteAcceptDeleteConfirmBtn': '削除して参加',
    'inviteAcceptDone': '「{workspace}」に参加しました。画面を読み込み直します。',
    'inviteAcceptErrorNotFound': 'この招待リンクは無効です。招待した人に再送信を依頼してください',
    'inviteAcceptErrorAlreadyMember': 'このワークスペースには既に参加しています',
    'backToLogin': 'ログインに戻る',
    'updatePasswordDescription': '新しいパスワードを入力してください。',
    'newPassword': '新しいパスワード',
    'newPasswordConfirm': 'パスワード（確認）',
    'newPasswordConfirmPlaceholder': 'もう一度入力',
    'passwordRuleHint': '12文字以上にしてください。覚えやすい言葉をいくつかつなげるのがおすすめです',
    'updatePasswordBtn': 'パスワードを更新',
    'updatePasswordSuccessMsg': 'パスワードを更新しました。ログインしてください。',
    'signupPasswordError': 'パスワードは12文字以上にしてください（72バイトまで）',
    'signupConfirmEmailSentTo': '{email} にメールを送りました。メールの案内に沿って進めると登録が完了します。',
    'confirmEmailDone': 'メールアドレスを確認しました',
    'confirmEmailEnterPassword': '登録のときに決めたパスワードを入力してログインすると、メールアドレスの確認が完了します。',
    'confirmEmailInvalid': '確認のリンクが無効か期限切れです。同じアドレスでもう一度新規登録すると、パスワード再設定のメールが届きます。再設定すると確認も済みます。',
    'passwordMismatch': 'パスワードが一致しません',
    // settings shell (#1473)
    'settingsGroupYou': 'あなた',
    'settingsGroupWorkspace': 'ワークスペース',
    'settingsNavProfile': 'プロフィール',
    'settingsNavAiPref': 'AIプリファレンス',
    'settingsNavStyle': '文体プロファイル',
    'settingsNavMyConnections': '接続と認証',
    // account security (#3374)
    'mfaTitle': '二段階認証',
    'mfaNote': 'ログインのとき、パスワードに加えて認証アプリ（Google Authenticator など）の6桁のコードを求めます。パスワードが漏れても、スマートフォンがなければログインできません。',
    'mfaStatusOn': '有効です。Web・Chrome 拡張・AI 接続のログインで6桁のコードを求めます。',
    'mfaStatusOff': 'まだ使っていません。',
    'mfaEnableBtn': '二段階認証を有効にする',
    'mfaSetupStep1': 'スマートフォンの認証アプリで、下の QR コードを読み取ります。',
    'mfaSetupStep2': 'アプリに出た6桁のコードを入力して「有効にする」を押します。',
    'mfaQrAlt': '認証アプリで読み取る QR コード',
    'mfaSecretLabel': 'QR コードを読めないときは、このキーを入力します：',
    'mfaCodeLabel': '6桁のコード',
    'mfaCodeHint': '二段階認証が有効なアカウントです。認証アプリに表示されている6桁のコードを入力してください。',
    'mfaActivateBtn': '有効にする',
    'mfaActivateHint': '有効にすると、ほかの端末のログインと AI の接続はいったん切れます。次に使うときに、コードを入れて入り直してください。',
    'mfaEnabledToast': '二段階認証を有効にしました',
    'mfaDisableBtn': '二段階認証を無効にする',
    'mfaDisableCodeLabel': '確認のため、今の6桁のコード',
    'mfaDisableConfirm': '無効にする',
    'mfaDisabledToast': '二段階認証を無効にしました',
    'aiConnectionsTitle': '接続中の AI',
    'aiConnectionsNote': 'Zenmetry を読み書きできる AI です。心当たりのないものや使わなくなったものは解除してください。解除した AI は、もう一度接続するまで Zenmetry を使えません。',
    'aiConnectionsEmpty': '接続中の AI はありません。',
    'aiConnectionsOrderNote': 'AI の作業は、その作業に使える道具を申告した AI のうち、上にある AI に任せます。並べ替えるまでは、最後に道具を申告した AI に任せます。',
    'aiConnectionOrder': '{n}番目',
    'aiConnectionMoveUp': '上へ',
    'aiConnectionMoveDown': '下へ',
    'aiConnectionOrderSaved': 'AI の順番を保存しました',
    'aiConversationPlaceHint': '「まとめと判断を届ける場所」は、決まった時刻などに AI が自分から送るときの宛先です。話しかけたときは、その会話で返します。',
    'aiConnectionSessions': '接続の管理（{n} 件）',
    'aiConversationPlaceLabel': 'まとめと判断を届ける場所',
    'aiConversationPlaceConversation': 'この AI との会話',
    'aiConversationPlaceSlackDm': '自分への Slack DM',
    'aiConversationPlaceSaved': '届ける場所を保存しました',
    'aiConnectionConnectedAt': '{time} に接続',
    'aiConnectionLastUsedAt': '最後の利用 {time}',
    'aiConnectionRevoke': '接続を解除',
    'aiConnectionRevokeConfirm': '解除する',
    'aiConnectionRevokedToast': '{name} の接続を解除しました',
    'accountEndTitle': '利用を終える',
    'accountEndNote': '利用を終えると、すぐにログインできなくなり、Gmail・カレンダー・Slack・AI との接続も止まります。14 日後に、ゴールなどのデータとアカウントをすべて削除します。14 日以内なら、support@zenmetry.net に連絡すると取り消せます。',
    'accountEndBtn': '利用を終える',
    'accountEndEmailLabel': '確認のため、ログインしているメールアドレスを入力してください',
    'accountEndConfirm': '利用を終える',
    'accountEndDoneToast': '利用を終えました。14 日後にデータを削除します。',
    'settingsNavAdvanced': '詳細設定',
    'settingsNavMembers': 'メンバーと招待',
    'settingsNavIntegrationPolicy': '連携ポリシー',
    'settingsNavSyncRules': '同期ルール',
    'settingsBadgePersonal': '個人',
    'settingsBadgePersonalHint': '他のメンバーには共有されません',
    'settingsBadgeWorkspaceShared': 'ワークスペース共有',
    'settingsBadgeWorkspaceSharedHint': 'ワークスペースのメンバー全員に共有されます',
    'settingsCrumb': '/ 設定',
    'settingsTitle': '設定',
    'settingsMenuOpen': 'メニュー',
    'settingsMenuTitle': '設定メニュー',
    'settingsSaveRegionLabel': 'プロフィール設定の保存',
    'settingsUnsavedChanges': '未保存の変更があります',
    'settingsSaveScope': 'プロフィール・AIプリファレンス・詳細設定をまとめて保存します。AIに任せる業務は、選んだときに保存されます。',
    'settingsSaveProfileChanges': 'プロフィールと環境設定を保存',
    'settingsDiscardChanges': '変更を破棄',
    'settingsChangesDiscarded': '変更を破棄しました',
    'settingsDiscardReloadError': '最新の設定を読み込めませんでした。変更は保持されています。',
    'settingsSaving': '保存中',
    'settingsProfileSaved': 'プロフィール設定を保存しました',
    'settingsProfileSavePartialError': '一部の変更を保存できなかった可能性があります。再試行するとすべての設定を保存し直します。',
    'settingsUnsavedExitConfirm': 'プロフィール設定に未保存の変更があります。変更を破棄して設定を閉じますか？',
    'settingsUnsavedWorkspaceExitConfirm': 'ワークスペース共有設定に未保存の変更があります。変更を破棄して設定を閉じますか？',
    'settingsSectionPlaceholder': 'この項目は準備中です',
    'settingsMembersDescription': 'メンバーの招待、ロール変更、削除はワークスペース管理から行えます。',
    'settingsMembersAction': 'メンバーを管理',
    'settingsYouGroupNote': 'このグループの設定はあなた個人のものです。ワークスペースの他のメンバーには共有されません（表示名を除く）。',
    'settingsWorkspaceGroupNote': 'このワークスペースのゴール・イベント・タスクは、メンバー全員に表示されます。個人設定・接続の認証情報は共有されません。',
    'myConnectionsNote': '接続アカウントごとに、取り込みのON/OFF、共有範囲、取り込み条件を管理します。',
    'myConnectionsLoading': '読み込み中…',
    'myConnectionsEmpty': 'まだ接続されたアカウントがありません。',
    'myConnectionsConnectAction': 'アカウントを接続',
    'myConnectionsConnectGoogleAction': 'Googleを接続',
    'myConnectionsConnectSlackAction': 'Slackを接続',
    'myConnectionsConnectedAt': '{date} に接続',
    'myConnectionsStatusActive': '認証済み',
    'myConnectionsStatusRevoked': '解除済み（取り込んだデータは残っています）',
    'myConnectionsGroupGoogle': 'Google アカウント',
    'myConnectionsGroupGoogleNote': 'Gmail とカレンダーは同じ Google アカウントでつながり、解除もまとめて行われます。',
    'myConnectionsPurgeRevokedAction': 'データも削除',
    'myConnectionsReconnectAction': 'つなぎ直す',
    'myConnectionsPurgeRevokedConfirmMessage': 'この接続から取り込んだ元データを削除しますか？すでに作成されたゴール・タスクは残ります。',
    'myConnectionsPurgeRevokedConfirmOk': '削除する',
    'myConnectionsPurgeRevokedSuccess': '取り込み済みデータを削除しました',
    'myConnectionsPurgeRevokedError': '削除に失敗しました',
    'myConnectionsStatusError': '接続を確認できません',
    'myConnectionsDisclosureHint': 'Enter または Space で接続詳細を開閉',
    'myConnectionsDisconnectAction': '解除',
    'myConnectionsPurgeHint': '解除時に、取り込み済みデータの削除を選べます',
    'myConnectionsConfirmMessage': 'この接続を解除しますか？',
    'myConnectionsConfirmGoogleMessage': 'この Google アカウントの接続（Gmail とカレンダー）を解除しますか？',
    'myConnectionsConfirmPurgeLabel': '取り込み済みデータも削除する',
    'myConnectionsConfirmPurgeHint': '接続から取り込んだ元データを削除します。すでに作成されたゴール・タスクは残ります。',
    'myConnectionsConfirmCancel': 'キャンセル',
    'myConnectionsConfirmOk': '解除する',
    'myConnectionsLoadError': '接続アカウントの読み込みに失敗しました',
    'myConnectionsConnectError': '接続の開始に失敗しました',
    'myConnectionsDisconnectSuccess': '接続を解除しました',
    'myConnectionsDisconnectError': '解除に失敗しました',
    'connectionRowIngestLabel': '取り込み',
    'connectionRowCalendarIngestLabel': 'このGoogleアカウントのカレンダー取り込み',
    'connectionRowIngestOnReadback': '取り込み ON',
    'connectionRowIngestOffReadback': '取り込み OFF',
    'connectionRowCalendarIngestOnReadback': 'このGoogleアカウントのカレンダー取り込み ON',
    'connectionRowCalendarIngestOffReadback': 'このGoogleアカウントのカレンダー取り込み OFF',
    'connectionRowVisibilityLabel': '共有範囲',
    'connectionRowVisibilityPrivate': '非公開',
    'connectionRowVisibilityShared': 'ワークスペース共有',
    'connectionRowShareScopeReadback': '共有範囲: {scope}',
    'connectionRowGoogleDetailDescription': 'アカウント単位の取り込みと共有範囲を設定できます。',
    'connectionRowSlackDetailDescription': 'Slack の取り込みと共有範囲を設定できます。詳細な取り込み条件は現在変更できません。',
    'connectionRowFilterHeading': '取り込み条件',
    'connectionRowFilterUnavailableDescription': '詳細な取り込み条件は現在変更できません。',
    'connectionFilterLoading': 'Googleから設定候補を読み込んでいます…',
    'connectionFilterDegraded': 'Googleから一覧を取得できませんでした。保存済みの条件を読み取り専用で表示しています。',
    'connectionFilterSave': '取り込み条件を保存',
    'gmailGlobalFilterSave': 'カテゴリ・アドレスを保存',
    'gmailLabelFilterSave': 'この接続のラベルを保存',
    'connectionFilterSaveSuccess': '取り込み条件を更新しました',
    'connectionFilterSaveError': '取り込み条件の更新に失敗しました。保存済みの設定を再読み込みしました。',
    'gmailFilterCategories': '取り込むカテゴリ',
    'gmailFilterExcludedSenders': '除外する送信者（1行に1件）',
    'gmailFilterExcludedRecipients': '除外する宛先（1行に1件）',
    'gmailFilterLabels': 'Inbox内でさらに除外するGmailラベル',
    'gmailFilterLabelsHint': 'Gmailから取り込む基本対象はInboxのメールです。Spamやゴミ箱などInboxに入らないラベルは通常ここで除外する必要はありません。',
    'gmailCategory_CATEGORY_PERSONAL': 'メイン',
    'gmailCategory_CATEGORY_SOCIAL': 'ソーシャル',
    'gmailCategory_CATEGORY_PROMOTIONS': 'プロモーション',
    'gmailCategory_CATEGORY_UPDATES': '新着',
    'gmailCategory_CATEGORY_FORUMS': 'フォーラム',
    'calendarModeOff': '取り込まない',
    'calendarModeEventsOnly': '予定として参照',
    'calendarModeGoals': 'ゴールに紐づける',
    'connectionRowRevokedDescription': 'この接続は解除済みです。設定を変えるには、つなぎ直してください。',
    'connectionRowErrorDescription': '接続を確認できないため、この接続の設定は変更できません。時間をおいて再度確認するか、接続し直してください。',
    'connectionRowIntegrationNotAllowedDescription': 'このワークスペースでは、この連携からの取り込みが許可されていません。設定を変更するにはワークスペースの管理者に確認してください。',
    'connectionRowReadOnlyHint': 'この連携の設定は現在変更できません',
    'connectionRowIntegrationNotAllowedHint': 'このワークスペースでは取り込みが許可されていません',
    'connectionRowIngestAriaLabel': '{provider} の取り込みを切り替える',
    'myConnectionsIngestOnSuccess': '取り込みを有効にしました',
    'myConnectionsIngestOffSuccess': '取り込みを無効にしました',
    'myConnectionsIngestUpdateError': '取り込み設定の更新に失敗しました',
    'myConnectionsVisibilitySuccess': '共有範囲を変更しました',
    'myConnectionsVisibilityError': '共有範囲の変更に失敗しました',
    'styleProfileNote': 'Gmail・Slack の過去メッセージから分析した文体を、メール・Slack の下書き生成に使います。学習できない場合は詳細設定の文体設定を使います。',
    'styleProfileLoading': '読み込み中…',
    'styleProfileEmpty': 'まだ分析されていません。Claude で style-analyzer スキルを実行するとここに表示されます。',
    'styleProfileNotAnalyzedAlert': 'まだ分析されていません。Claude で「style-analyzer を実行して」と依頼すると、ここに文体プロファイルが表示されます。',
    'styleProfileEmptyTitle': '文体プロファイルは未作成です',
    'styleProfileEmptyDescription': 'クリックすると Claude に貼る文面をコピーして開きます。分析後は次回以降の下書きであなたの文体を参照できます。',
    'styleProfileCopyPromptAction': 'Claudeで文体を分析',
    'styleProfileAnalyzerPrompt': 'Zenmetry の style-analyzer を実行して、Gmail・Slack の過去メッセージから私の文体プロファイルを作成してください。',
    'styleProfileResultLabel': '分析結果',
    'styleProfileAnalyzedAt': '最終分析: {date}',
    'styleProfileToneAxis': 'トーン',
    'styleProfileSentenceLengthAxis': '文の長さ',
    'styleProfileFormalityAxis': '丁寧さ',
    'styleProfileReanalyzeInfo': '更新するときも同じ依頼文を Claude に渡します。',
    'styleProfileLoadError': '文体プロファイルの読み込みに失敗しました',
    'integrationPolicyNote': 'このワークスペースで許可する連携を管理します。',
    'integrationPolicyLoading': '読み込み中…',
    'integrationPolicyLoadError': '連携ポリシーの読み込みに失敗しました',
    'integrationPolicySaveSuccess': '連携ポリシーを更新しました',
    'integrationPolicySaveError': '連携ポリシーの更新に失敗しました',
    'integrationPolicyRowSub': '{provider} から自動でゴール・タスクを検出します',
    'integrationPolicyAllowLabel': '取り込みの許可',
    'integrationPolicyAllowAriaLabel': '{provider} 連携を許可する',
    'integrationPolicyMemberReadOnlyHint': '変更は workspace owner のみ行えます',
    'integrationPolicyMemberNote': 'メンバーの招待・ロール変更は、ワークスペースの owner が行えます。連携ポリシーの変更も owner のみです。',
    'integrationPolicyCrossLinkNote': '個別アカウントの取り込みON/OFF・共有範囲・解除は「あなた ＞ 接続と認証」から管理します。',
    'integrationPolicyGhostGoogleCalendar': 'Google カレンダー — 近日対応',
    'integrationPolicyGhostSlack': 'Slack — 近日対応',
    'integrationMemberStatusConnected': '接続済み',
    'integrationMemberStatusNotConnected': '未接続',
    'integrationMemberStatusPaused': '一時停止',
    'integrationMemberStatusReauth': '要再接続',
    'integrationMemberStatusHeading': 'メンバーの接続状況',
    'integrationMemberVisibilityMixed': '接続ごとに異なる',
    // workspace panel (#1239)
    'workspaceMenuItem': 'ワークスペース',
    'workspaceUnavailable': 'ワークスペース機能は利用できません',
    'workspaceTitle': 'ワークスペース',
    'workspaceSharedNotice': 'このワークスペースのゴールと予定は、既存のものを含めて参加メンバーに共有されます。',
    'workspaceMemberCount': 'メンバー {count} 名',
    'workspaceMembersHeading': 'メンバー',
    'workspaceRoleOwner': 'オーナー',
    'workspaceRoleAdmin': '管理者',
    'workspaceRoleMember': 'メンバー',
    'workspaceRoleGuest': 'ゲスト',
    'workspaceMemberFallbackName': '（名前未設定）',
    'workspaceChangeRole': 'ロールを変更',
    'workspaceRemoveMember': '削除',
    'workspaceRemoveMemberConfirm': '{name} をワークスペースから削除しますか？この人がこのワークスペースでつないだ Gmail・カレンダー・Slack の連携も解除され、取り込みが止まります。取り込み済みのゴールと予定は残ります。この操作は取り消せません。',
    'workspaceRemoveMemberConfirmBtn': '削除する',
    'workspaceRemoveMemberCancelBtn': 'キャンセル',
    'workspaceRemoveMemberSuccess': 'メンバーを削除しました',
    'workspaceRoleUpdateSuccess': 'ロールを更新しました',
    'workspaceInvitationsHeading': '招待中のメンバー',
    'workspaceInviteEmailPlaceholder': 'メールアドレス',
    'workspaceInviteRoleLabel': '招待するロール',
    'workspaceInviteSubmitBtn': '招待を送信',
    'workspaceInviteResendBtn': '再送信',
    'workspaceInviteRevokeBtn': '取り消す',
    'workspaceInviteRevokeConfirm': '{email} 宛の招待を取り消しますか？',
    'workspaceInviteRevokeConfirmBtn': '取り消す',
    'workspaceInviteCreateSuccess': '招待メールを送信しました',
    'workspaceInviteResendSuccess': '招待メールを再送信しました',
    'workspaceInviteDeliveryFailed': '招待は作成しましたが、メールを送れませんでした。しばらくしてから「再送信」してください',
    'workspaceInviteResendDeliveryFailed': '招待は更新しましたが、メールを送れませんでした。しばらくしてからもう一度「再送信」してください',
    'workspaceInviteRevokeSuccess': '招待を取り消しました',
    'workspaceInviteStatusPending': '招待中',
    'workspaceInviteStatusConsumed': '参加済み',
    'workspaceInviteStatusRevoked': '取り消し済み',
    'workspaceInviteStatusExpired': '期限切れ',
    'workspaceInviteStatusUnknown': '不明',
    'workspaceInviteExpiresAt': '有効期限: {date}',
    'workspaceInviteMailNote': '招待した相手には、参加用のリンクが入ったメールが届きます。',
    'workspaceNoMembers': 'メンバーがいません',
    'workspaceNoInvitations': '招待中のメンバーはいません',
    'workspaceLoading': '読み込み中...',
    'workspaceErrorMembershipMissing': 'このワークスペースのメンバーではありません',
    'workspaceErrorMultipleMemberships': 'ワークスペースの状態を確認できませんでした',
    'workspaceErrorNotFound': 'ワークスペースが見つかりません',
    'workspaceErrorAdminForbidden': 'この操作を行う権限がありません',
    'workspaceErrorMemberNotFound': '対象のメンバーが見つかりません',
    'workspaceErrorLastOwnerProtected': '最後のオーナーのロールは変更・削除できません',
    'workspaceErrorInvalidRole': '選択できないロールです',
    'workspaceErrorInvalidEmail': '有効なメールアドレスを入力してください',
    'workspaceErrorInvalidInvitation': '招待情報が正しくありません',
    'workspaceErrorInvitationNotFound': '招待が見つかりません',
    'workspaceErrorInvitationConflict': '招待の状態が変更されています。再読み込みしてください',
    'workspaceErrorInviteTargetConflict': 'このメールアドレスは、他のメンバーがいるワークスペースに既に参加しています',
    'workspaceErrorInviteTargetAmbiguous': 'このメールアドレスに対応するアカウントを特定できません',
    'workspaceErrorInvitationRevoked': 'この招待は取り消し済みです',
    'workspaceErrorInvitationConsumed': 'この招待は既に使用されています',
    'workspaceErrorInvitationExpired': 'この招待は期限切れです',
    'workspaceErrorInvitationEmailMismatch': 'この招待は別のメールアドレス宛です。招待されたメールアドレスでログインしてください',
    'workspaceErrorActiveMembershipConflict': '他のメンバーがいるワークスペースに所属しているため、この招待は受けられません',
    'workspaceErrorMigrationConflict': 'ゴールや予定の移行で競合が起きました。削除して参加するか、サポートにお問い合わせください',
    'workspaceErrorInvalidAcceptanceMode': '参加のしかたを選んでください',
    'workspaceErrorGeneric': '操作に失敗しました。しばらくしてから再度お試しください',
    'profilePersonalSourceNotice': '連携アカウントや通知設定はあなた個人の設定です。同期されたゴールや予定だけがワークスペースに共有されます。',
    // workspace sync rules (#1473 C2/C3; persistence only)
    'workspaceSyncRulesNote': 'カレンダーの同期範囲と、期日のないゴールの既定値をワークスペース単位で管理します。対象カレンダーの選択は個人の接続設定で行います。',
    'workspaceSyncRulesLoading': '同期ルールを読み込み中…',
    'workspaceSyncRulesLoadError': '同期ルールを読み込めませんでした',
    'workspaceSyncRulesGenericError': '同期ルールを保存できませんでした。入力を確認して再度お試しください',
    'workspaceSyncRulesOwnerOnlyNote': '共有設定を変更できるのはワークスペースの owner だけです。現在の値を読み取り専用で表示しています。',
    'workspaceSyncRulesCalendarHeading': 'カレンダー同期',
    'workspaceSyncRulesCalendarDescription': 'ワークスペース全体で参照するカレンダー同期の期間と終日イベントの扱いです。',
    'workspaceSyncRulesWindowLabel': '取得期間',
    'workspaceSyncRulesWindowHint': '今日から何日先までの予定を同期するかを指定します。',
    'workspaceSyncRulesDays': '日間',
    'workspaceSyncRulesExcludeAllDayLabel': '終日イベントを同期しない',
    'workspaceSyncRulesExcludeAllDayHint': 'オンにすると終日イベントはワークスペースへの同期対象から除外されます。',
    'workspaceSyncRulesExcludeAllDayOn': '除外する',
    'workspaceSyncRulesExcludeAllDayOff': '除外しない',
    'workspaceSyncRulesCalendarConnectionLink': '対象カレンダーの選択は「あなた ＞ 接続と認証」で行います',
    'workspaceSyncRulesGoalHeading': '期日のないゴール',
    'workspaceSyncRulesGoalDescription': '期日が指定されていないゴールについての既定値です。現在は保存と表示のみで、ゴール生成には反映されません。',
    'workspaceSyncRulesNoDueDateLabel': '期日のないゴールの扱い',
    'workspaceSyncRulesNoDueDateHint': 'この設定は保存のみ対応しています。生成への反映は別途対応予定です。',
    'workspaceSyncRulesNoDueDate_keep_empty': '期日なしのままにする',
    'workspaceSyncRulesNoDueDate_propose_estimate': '期日の候補を提案する',
    'workspaceSyncRulesNoDueDate_create_decide_task': '期日を決めるタスクを作る',
    'workspaceSyncRulesSave': '共有設定を保存',
    'workspaceSyncRulesSaving': '保存中',
    'workspaceSyncRulesSaveSuccess': '共有設定を保存しました',
    'workspaceSyncRulesReadbackError': '保存済みですが、最新値を再確認できませんでした。再読み込みしてください',
    'workspaceSyncRulesReload': '最新値を再読み込み',
    'workspaceSyncRulesUnsaved': '未保存の変更があります',
    'workspaceSyncRulesInvalidWindow': '取得期間は1以上の整数で指定してください',
  },
  en: {
    // auth
    'login': 'Log in',
    'loggingIn': 'Logging in...',
    'loginRequired': 'Login required',
    'logout': 'Log out',
    'email': 'Email',
    'password': 'Password',
    'emailPasswordRequired': 'Please enter your email and password',
    'forgotPassword': 'Forgot your password?',
    'noAccount': "Don't have an account?",
    'signupLink': 'Sign up here',
    'oauthLoginBtn': 'Sign in with Google',
    // capture
    'captureBtn': 'Capture & Create',
    'capturing': 'Capturing...',
    'captureFailed': 'Capture failed: {msg}',
    'analyzing': 'Analyzing...',
    'hint2040sec': 'Takes about 20–40 seconds',
    'pasteFromClipboard': 'Paste from clipboard',
    'uploadImage': 'Upload image',
    'createFromText': 'Create from text',
    'analyzingQueue1': 'Analyzing screenshot...',
    'analyzingQueueN': 'Analyzing {done}/{total}...',
    'memoPlaceholder': 'Optional note: date, context, requester...',
    'deadlineOptional': 'Deadline (optional)',
    'submit': 'Create',
    'skip': 'Skip',
    'cancel': 'Cancel',
    'textPlaceholder': 'Enter or paste text...',
    // tabs / filters
    'tabToday': 'Today',
    'tabReview': 'Review',
    'tabAll': 'All',
    'tabDone': 'Done',
    'appRailGoals': 'Goals',
    'nothingDueToday': 'Nothing due today',
    'nothingDueTodayHint': 'Anything due later is under All',
    'tabCreate': '+ Create',
    'appRailLabel': 'Main menu',
    'appRailCreate': 'Create',
    'appRailAccount': 'Account',
    'sectionOverdue': 'Overdue',
    'sectionToday': 'Today',
    'sectionTomorrow': 'Tomorrow',
    'sectionThisWeek': 'This Week',
    'sectionFuture': 'Later',
    'sectionNone': 'No Deadline',
    'sectionSchedule': 'Schedule',
    // empty states
    'noTasksToday': 'Nothing to do right now',
    'noTasksAll': 'No goals yet',
    'noTasksHint': 'Capture a screenshot or paste text to create goals',
    'noTasksFiltered': 'No matching goals',
    'allGoalsDone': 'All goals completed!',
    'allGoalsDoneHint': 'Create a new goal or sync from Claude',
    'noReviewTasks': 'No goals awaiting review',
    'emptyStateTitle': 'Get Started',
    'emptyStateSubtitle': '3 ways to create goals',
    'emptySyncTitle': 'Sync from Claude Desktop',
    'emptySyncDesc': 'Auto-create goals from Gmail, Slack & Calendar',
    'emptySyncStep1': 'Open the Claude Desktop app',
    'emptySyncStep2': 'Type "sync" and send',
    'emptySyncStep3': 'Goals will be auto-created from Gmail, Slack & Calendar',
    'emptySyncSetupLink': 'New here? Check the setup guide',
    'emptyScreenshotTitle': 'Create with Chrome extension',
    'emptyScreenshotDesc': 'Take a screenshot from the side panel and AI extracts goals automatically',
    'emptyTextTitle': 'Create from text',
    'emptyTextDesc': 'Paste text to create goals',
    // subtasks
    'addSubtask': 'Add task',
    'addSubtaskOrFeedback': 'Add task or request adjustments',
    'feedbackRecorded': 'Noted on this goal',
    'done': 'Done',
    'retry': 'Redo',
    'approve': 'Approve',
    'rejectFeedbackPlaceholder': 'Feedback (optional): what should be changed',
    'rejectConfirm': 'Retry with feedback',
    'reviewing': 'Review',
    'executing': 'Executing',
    'pending': 'Pending',
    'inProgress': 'In Progress',
    'subtaskGenerating': 'Generating tasks...',
    'noSubtasks': 'No tasks',
    // goal actions
    'delete': 'Delete',
    'save': 'Save',
    'edit': 'Edit',
    'confirmDelete': 'Delete "{title}"?',
    'confirmDeleteGoal': 'Delete "{title}"? This can\'t be undone.',
    // #1929 S4: the review's completion candidate after a task is done
    'completionSuggestedMsg': '"{title}" looks done. Complete it?',
    'completionSuggestedAction': 'Complete',
    'completionSuggestedDone': 'Completed the goal.',
    'goalDeleted': 'Goal deleted',
    'goalDeleteFailed': 'Delete failed',
    // deadline
    'today': 'Today',
    'tomorrow': 'Tomorrow',
    'noDeadline': 'No deadline',
    'setDeadline': 'Set deadline',
    // priority
    'priorityHigh': 'High',
    'priorityMedium': 'Medium',
    'priorityLow': 'Low',
    'priorityNone': '-',
    'setPriority': 'Set priority',
    'prioritySet': 'Priority set to "{p}"',
    // messages / toasts
    'goalsCreated': '{count} goals created',
    'goalCreated1': 'Goal created',
    'shiftedDays': 'Moved {count} day(s) later',
    'copied': 'Copied',
    'saved': 'Saved',
    'profileSaved': 'Profile saved',
    // errors
    'errorNetwork': 'Cannot connect to server. Please check your network connection.',
    'errorServer': 'Server is temporarily unavailable. Please try again later.',
    'errorTimeout': 'Server response timed out. Please try again later.',
    'errorTooMany': 'Too many requests. Please try again later.',
    'errorGeneral': 'An error occurred',
    'errorServerGeneral': 'Server error. Please try again later.',
    'clipboardFailed': 'Failed to read from clipboard',
    'clipboardWriteFailed': 'Failed to copy to clipboard',
    'clipboardNoImage': 'No image in clipboard',
    'textEmpty': 'Please enter some text',
    'analysisFailed': 'Analysis failed',
    // profile
    'profileDisplayName': 'Display name',
    'profileDisplayNamePlaceholder': 'Hanako Sato',
    'profileDisplayNameHint': 'Shown to workspace members',
    'profileEmail': 'Email',
    'profileEmailUnavailable': 'Email unavailable',
    'profileName': 'Names that refer to you',
    'profileNameHint': 'Used to recognize requester and assignee names in screenshots and connected data',
    'profileNamePlaceholder': 'John Doe, John, J. Doe (comma-separated)',
    'profileRole': 'Role',
    'profileRolePlaceholder': 'e.g. Product Manager, Engineer',
    'profileLocation': 'Base 1',
    'profileLocationPlaceholder': 'e.g. Shibuya station, Roppongi office',
    'profileLocationHint': 'Used to estimate travel time for in-person meetings',
    'profileLocation2': 'Base 2',
    'profileLocation2Placeholder': 'e.g. Futako-Tamagawa station (leave empty if none)',
    'profileWeekdayDaytimeLocation': 'Base for weekday daytime',
    'profileWeekdayDaytimeLocationHint': 'Events starting 9:00–19:00 on weekdays are reached from this base, other times from the other one. If an earlier event that day has a place, you leave from there.',
    'profileInterests': 'Interests',
    'profileInterestsPlaceholder': 'e.g. AI, Design, Investing (comma-separated)',
    'profileGoals': 'Current goals',
    'profileGoalsPlaceholder': 'e.g. Launch MVP, Improve English (comma-separated)',
    'profileBioPlaceholder': 'Any other notes or preferences for AI (optional)',
    'profileTimezone': 'Timezone',
    'profileTimezoneHint': 'Used for deadline detection (auto-detected from browser)',
    'profileLanguage': 'Language',
    'profileLanguageHint': 'Used for Zenmetry UI and language-dependent helper copy. AI draft tone also uses writing-style settings.',
    'profileSaveBtn': 'Save',
    'profileTitle': 'Profile Settings',
    'profileAIPref': 'AI behavior settings',
    'profileAdvancedSettings': 'Advanced settings',
    'profileWhereHint': 'Used to decide whether AI should create a goal, who the work belongs to, and which service to use for drafting or execution.',
    'profileWhereAccounting': 'Accounting',
    'accTaskPayments': 'Payments & receipts',
    'accTaskInvoices': 'Invoice issuance',
    'accTaskExpenses': 'Expense reimbursement',
    'accExecUnset': '(not set)',
    'accExecSelf': 'I execute it',
    'accExecDelegate': 'Someone else executes it',
    'accExecNone': 'Do not execute',
    'accExecDelegatePreserved': 'Previous setting: someone else executes it',
    'accExecPreserved': 'Keep previous setting: {value}',
    'accSystemLabel': 'System',
    'accTaxReview': 'Tax accountant does final review',
    'profileWhereMail': 'Service for sending mail',
    'profileWhereSchedule': 'Service for creating events',
    'profileWhereUnset': 'Not set',
    'profileWhereOther': 'Other',
    'profileWherePaper': 'Paper planner',
    'prefCommExternal': 'External email / communication',
    'prefCommFormal': 'Formal / polite',
    'prefCommBusinessCasual': 'Business casual',
    'prefCommAuto': 'Match the other party',
    'prefCommInternal': 'Internal Slack / communication',
    'prefCommCasual': 'Casual',
    'prefCommFormal2': 'Polite',
    'prefCommAuto2': 'Match the other party',
    'prefCommFallbackHint': 'Fallback for messaging services where the writing style profile cannot be learned.',
    'prefTaskGranularity': 'Task breakdown granularity',
    'prefTaskFine': 'Fine (5–15 min)',
    'prefTaskNormal': 'Normal',
    'prefTaskCoarse': 'Coarse (30+ min)',
    'prefTaskGranularityHint': 'Only change this if needed. In most cases, Normal is enough.',
    'prefNoReminder': 'Don\'t auto-generate reminder subtasks',
    'prefAddTravel': 'Add travel time subtasks for in-person meetings',
    'prefTravelMode': 'Travel mode',
    'prefTravelModeHint': 'Used with your location to estimate travel time for in-person meetings.',
    'prefTravelTrain': 'Train',
    'prefTravelCar': 'Car',
    'prefTravelPlane': 'Plane',
    'prefTravelUndecided': 'Undecided',
    'prefMeetingDefaultAttendance': 'Default meeting attendance',
    'prefMeetingDefaultAttendanceHint': 'Used for recommendations when both in-person and online are possible.',
    'prefMeetingDefaultAttendanceAuto': 'Decide from context',
    'prefMeetingDefaultAttendanceInPerson': 'Prefer in-person',
    'prefMeetingDefaultAttendanceOnline': 'Prefer online',
    'prefEventDefaultAttendance': 'Default event attendance',
    'prefEventDefaultAttendanceHint': 'Used as a heuristic for seminars and conferences when both options exist.',
    'prefEventDefaultAttendanceAuto': 'Decide from context',
    'prefEventDefaultAttendanceInPerson': 'Prefer attending in person',
    'prefEventDefaultAttendanceOnline': 'Prefer attending online',
    'prefUnreadDeadline': 'Deadline when none is stated',
    'prefUnreadDeadlineHint': 'Used as a tentative deadline for goals whose email or screenshot states none. Counted from the day the goal was created; weekends are not business days. Tentative deadlines are checked in the morning check.',
    'prefUnreadDeadlineSameDay': 'Same day',
    'prefUnreadDeadlineNextBusinessDay': 'Next business day',
    'prefTravelWalk': 'Walk',
    'prefTravelBike': 'Bike',
    'aiWorkVerb_read': 'Read / look up',
    'aiWorkVerb_draft': 'Draft',
    'aiWorkVerb_send': 'Send',
    'aiWorkVerb_schedule': 'Schedule',
    'aiWorkVerb_respond_invite': 'Reply to invitations',
    'aiWorkVerb_make': 'Make (documents, invoices)',
    'aiWorkVerb_register': 'Register a record',
    'aiWorkVerb_apply': 'Submit your own request',
    'aiWorkVerb_update': 'Update',
    'aiWorkVerb_organize': 'Organize (label, move, upload)',
    'aiWorkVerb_delete': 'Delete',
    'aiWorkVerb_approve': "Approve others' requests",
    'aiWorkVerb_site_procedure': 'Use a website',
    'aiWorkVerb_pay': 'Pay',
    'settingsNavAiWork': 'Work left to AI',
    'aiWorkCardsDesc': 'For each step of your work, choose whether an AI does it on its own, an AI does it after you approve, or you do it yourself. Open a card to choose its steps, services, your preferences for it, and each AI\u2019s tools. Choices are saved right away.',
    'aiWorkStateAuto': 'AI on its own',
    'aiWorkStateCheck': 'AI after you approve',
    'aiWorkStatePrincipal': 'You (not AI)',
    'aiWorkStepAria': '{step}: {state}',
    'aiWorkStepMixed': 'Services differ here. Choosing sets all of this task\u2019s services the same.',
    'aiWorkSaveFailed': 'Could not save. Please try again.',
    'aiWorkStepFixed': 'Payments always need your approval, even when an AI does them.',
    'aiWorkStateShortAuto': 'AI',
    'aiWorkStateShortCheck': 'After approval',
    'aiWorkStateShortPrincipal': 'You',
    'aiWorkOpenCard': 'Details of {name}',
    'aiWorkAisCan': '{names} can do this',
    'aiWorkNoAiYet': 'No AI has declared it can do this yet',
    'aiWorkNoServiceYet': 'No service chosen yet',
    'aiWorkAddCard': 'Add a task',
    'aiWorkAddCardName': 'Task name',
    'aiWorkAddCardNamePlaceholder': 'Contracts',
    'aiWorkAddCardSteps': 'Steps it includes',
    'aiWorkAddCardSubmit': 'Add',
    'aiWorkRemoveCard': 'Remove this task',
    'aiWorkBreadcrumb': 'You are here',
    'aiWorkSteps': 'Steps',
    'aiWorkServices': 'Services used',
    'aiWorkSites': 'Websites',
    'aiWorkViaBrowser': '{service} (in the browser)',
    'aiWorkSiteAdd': 'Add a website',
    'aiWorkSitesPlaceholder': 'e-tax, e-gov',
    'aiWorkSitesHint': 'The AI works on websites through a browser. Add a website only when you want a different choice for it.',
    'aiWorkServicesHint': 'The services you usually use for this task. The AI works in them (in the browser when it has no tool for one). Add every one you use.',
    'aiWorkServiceAdd': 'Add a service',
    'aiWorkServiceRemove': 'Remove {service}',
    'aiWorkPrefs': 'Your preferences for this task',
    'aiWorkPrefWho': 'Who handles it',
    'aiWorkPrefWhoUnset': 'Not decided',
    'aiWorkPrefWhoSelf': 'You',
    'aiWorkPrefWhoDelegate': 'Someone you assign',
    'aiWorkPrefWhoNone': 'Not part of my work',
    'aiWorkPrefWhoHint': 'With "Someone you assign", the AI treats this work as something to ask someone for. With "Not part of my work", it leaves it out.',
    'aiWorkTools': 'Tools by AI',
    'aiWorkToolsHint': 'The tools your connected AIs declared. What you choose per tool stays when the AI declares again.',
    'aiWorkToolsLoading': 'Loading what the AIs declared',
    'aiWorkToolsError': 'Could not load what the AIs declared. Please reopen later.',
    'aiWorkToolsNeedService': 'Add a service to see the tools an AI can use in it.',
    'aiWorkToolsNone': 'No AI has declared tools for this task\u2019s services yet.',
    'aiWorkLastDeclared': 'Last checked {date} ({name})',
    'aiWorkBulk': 'All',
    'aiWorkBulkAria': 'All tools in {service}',
    'aiWorkToolReset': 'Reset',
    'aiWorkToolLabel': '{step} ({action})',
    'aiWorkToolAction_create': 'new',
    'aiWorkToolAction_update': 'update',
    'aiWorkToolAction_delete': 'delete',
    'aiWorkToolAction_reply': 'reply',
    'aiWorkToolAction_forward': 'forward',
    'aiWorkToolAction_search': 'search',
    'aiWorkToolAction_get': 'open one',
    'workCard_mail': 'Email replies',
    'workCard_schedule': 'Scheduling',
    'workCard_chat': 'Internal messages',
    'workCard_search': 'Finding documents',
    'workCard_quote': 'Quotes',
    'workCard_invoice': 'Invoices',
    'workCard_expense': 'Expense claims',
    'workCard_approval': 'Approving requests',
    'workCard_payment': 'Payments',
    'workCard_files': 'Organizing files',
    'workCard_site': 'Website procedures',
    'workStep_mail_read': 'Read',
    'workStep_mail_draft': 'Draft',
    'workStep_mail_send': 'Send',
    'workStep_schedule_read': 'Check availability',
    'workStep_schedule_send': 'Send options',
    'workStep_schedule_schedule': 'Add to calendar',
    'workStep_schedule_respond': 'Reply to invites',
    'workStep_chat_read': 'Read',
    'workStep_chat_draft': 'Draft',
    'workStep_chat_send': 'Send',
    'workStep_search_read': 'Find',
    'workStep_search_make': 'Summarize',
    'workStep_doc_make': 'Make',
    'workStep_doc_send': 'Send',
    'workStep_expense_apply': 'Submit',
    'workStep_approval_read': 'Check the content',
    'workStep_approval_approve': 'Approve',
    'workStep_payment_pay': 'Pay',
    'workStep_files_organize': 'Organize',
    'workStep_files_delete': 'Delete',
    'workStep_site_procedure': 'Complete it',
    'prefOtherBio': 'Additional notes (optional)',
    // dates
    'weekdays': ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    // goal done / priority titles
    'goalDoneUndo': 'Mark as incomplete',
    'goalDoneSet': 'Mark as done',
    'goalCompleted': 'Goal completed',
    'goalUncompleted': 'Marked as incomplete',
    // subtask counter / actions
    'tasksLabel': 'Tasks',
    'subtaskCompleted': 'Completed',
    'titleUpdated': 'Title updated',
    'dodUpdated': 'Definition of Done updated',
    'dodLabel': 'Completion criteria',
    'dodAdd': 'Add...',
    'dodDriftMsg': 'Tasks changed. Click to review completion criteria.',
    // bulk selection
    // decision
    'decisionConfirm': 'Confirm: "{label}"?',
    'decisionSuccess': 'Decision made',
    'decisionNext': 'Next',
    'followupGoalConfirm': 'Create the "{title}" goal?',
    'followupGoalCreated': 'Follow-up goal created',
    'followupGoalCreateError': 'Failed to create follow-up goal: {msg}',
    'decisionResetDone': 'Decision reset',
    'freeDecisionRequired': 'Please enter your selection',
    // calendar events
    'allDay': 'All day',
    'markDoneTitle': 'Mark as done',
    'markUndoneTitle': 'Mark as undone',
    'completedItems': '{n} completed',
    // ask AI
    'copyClaudeMobile': 'Copied! Open the Claude app and paste.',
    'copyClaudeDesktop': 'Copied! Opening Claude...',
    'askAISubtask': 'Consult with AI',
    // date picker
    'monthNames': ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'],
    'subtaskDeadlineHint': 'Set a date from today',
    // error messages
    'updateError': 'Update error: {msg}',
    'deadlineSetError': 'Deadline error: {msg}',
    'completionError': 'Completion error: {msg}',
    'dodError': 'DoD update error: {msg}',
    'decisionError': 'Decision error: {msg}',
    'decisionResetError': 'Reset error: {msg}',
    'deadlineUpdated': 'Deadline updated',
    'deadlineUpdateError': 'Deadline update error: {msg}',
    // #2489: Goal edits refused with 409, keyed by the server's code
    'goalUpdateConflictJudgment': 'This goal includes a decision, so changes to its completion criteria, deadline, start date, and similar fields could not be saved. You can still change the title and priority.',
    'goalUpdateConflictPending': 'This goal is still applying another change, so your edit could not be saved. Please wait a few minutes and try again.',
    'goalUpdateConflictDone': 'This goal is completed, so changes to its completion criteria, deadline, start date, and similar fields could not be saved. To change them, mark the goal as not completed first.',
    'goalUpdateConflictNotActive': 'This goal cannot be changed in its current state, so your edit could not be saved.',
    'goalUpdateConflictPartial': 'Only part of your change was applied. Reload to check the goal, and try again if needed.',
    'goalUpdateConflictGeneric': 'Your change could not be saved because it overlapped with another update. Please try again.',
    'goalUpdateConflictJudgmentRow': 'Completion criteria tied to a time choice cannot be rewritten or removed here. You can still change the other rows.',
    'goalUpdateConflictJudgmentHold': 'This decision has a chosen answer. Put it on hold before changing it.',
    'goalUpdateConflictDodRows': "This goal's completion criteria are edited row by row. Reload the page and try again.",
    'goalUpdateConflictCompatWrite': "Change this goal's completion criteria by editing its rows.",
    'goalUpdateConflictDodLastRow': 'A goal needs at least one completion criterion. Keep at least one row.',
    'goalUpdateConflictProposalStale': "The AI's plan has changed. Refresh and check it again.",
    'reviewProposalKeep': 'Keep going as is',
    'reviewProposalKept': 'Kept as is. This will not be proposed again until a new message arrives.',
    'reviewProposalWithdraw': 'Remove',
    'reviewProposalWithdrawn': 'Completion criterion removed.',
    'reviewProposalAddHint': 'To add one, write it in the completion criteria.',
    'reviewProposalAdd': 'Add this criterion',
    'reviewProposalAdded': 'Completion criterion added.',
    'reviewProposalRewrite': 'Rewrite to this',
    'reviewProposalRewritten': 'Completion criterion rewritten.',
    'reviewProposalRewriteHint': 'To rewrite it, edit the completion criterion.',
    'reviewProposalDraftHint': 'If the wording is off, edit the completion criterion.',
    'dodRowsAdd': 'Add a row',
    'dodRowsDelete': 'Remove this row',
    'dodRowsSave': 'Save',
    'dodRowsCancel': 'Cancel',
    'dodRowsJudgmentLocked': 'Rows tied to a time choice cannot be changed here.',
    'dodRowsJudgmentHint': 'Removing a decision row also removes its option rows. A decision with a chosen answer is put on hold before it changes.',
    'dodRowsHoldConfirm': 'This decision has a chosen answer. Put it on hold and make the change? Choose again after the change.',
    'dodRowsHoldConfirmAction': 'Hold and change',
    'deleteError': 'Delete error: {msg}',
    'approveError': 'Approve error: {msg}',
    'rejectError': 'Reject error: {msg}',
    // profile
    'loginStatus': 'Logged in as: {email}',
    'displayNameRequired': 'Please enter a display name',
    'onboardingNextBtn': 'Next',
    // goal deadline shift
    'subtaskAfterGoalDeadline': 'This deadline is after the goal deadline',
    // subtask deadline moved
    'subtaskMovedToFilter': 'Moved to "{label}"',
    'showAction': 'Show',
    // misc
    'langToggleLabel': '日本語',
    'backBtn': 'Back',
    // filters
    'filterLabelDeadline': 'Deadline',
    'filterLabelStatus': 'Status',
    'filterAll': 'All',
    'filterToday': 'Today',
    'filterTomorrow': 'Tomorrow',
    'filterThisWeek': 'This Week',
    'filterThisMonth': 'This Month',
    'filterOverdue': 'Overdue',
    'filterNone': 'No deadline',
    'filterActive': 'Active',
    'filterReview': 'Awaiting review',
    'filterDone': 'Done',
    'loadMoreDone': 'Show more',
    // create panel
    'inputModeScreenshot': 'Screenshot',
    'inputModeText': 'Text',
    'dropZoneText': 'Drag & drop screenshot here',
    'dropZoneHint': 'Click to select (multiple) / Ctrl+V to paste',
    'textAnalyzeBtn': 'Generate with AI',
    'textTaskPlaceholder': 'Enter goal content\n\nExamples:\n- Meeting with John next Monday\n- Submit proposal by Friday\n- Complete presentation by end of March',
    'createFabTitle': 'Create goal',
    'openInNewTab': 'Open in new tab',
    // signup form
    'pwHintLength': '12+ characters',
    'pwHintMatch': 'Passwords match',
    'agreeTermsPrefix': 'I agree to the ',
    'agreeTermsLink': 'Terms of Service',
    'agreeTermsAnd': ' and ',
    'agreePrivacyLink': 'Privacy Policy',
    'agreeTermsSuffix': '',
    'signupValidationTerms': 'You must agree to the Terms of Service and Privacy Policy',
    'signupTab': 'Sign up',
    'signupBtn': 'Create account',
    'signupName': 'Name',
    'signupNamePlaceholder': 'John Doe',
    'signupPasswordPlaceholder': '12+ characters',
    'resetDescription': 'Enter your registered email address. We will send you a password reset link.',
    'search': 'Search',
    'searchPlaceholder': 'Search goals...',
    'searchHint': 'Enter a search keyword',
    'searchEmptyMsg': 'No goals matching "{query}"',
    'searchResultsCount': '{count} result(s)',
    'closeLabel': 'Close',
    'resetBtn': 'Send reset email',
    'resetEmailSentTo': 'If {email} is registered, we sent a password reset email. If it does not arrive, check your spam folder, then try again after about 5 minutes.',
    'resetLinkInvalid': 'This link is invalid or has expired. Please request a new password reset.',
    'resetLinkUnverified': 'We could not check this link. Please wait a moment and request a new password reset.',
    'authInviteNotice': 'To accept the workspace invitation, log in or sign up with the invited email address.',
    // invitation accept screen (#2432)
    'inviteAcceptTitle': 'Workspace invitation',
    'inviteAcceptLoading': 'Checking the invitation…',
    'inviteAcceptSubmitting': 'Joining…',
    'inviteAcceptSummary': '{inviter} invited you to join "{workspace}" as {role}',
    'inviteAcceptSummaryNoInviter': 'You are invited to join "{workspace}" as {role}',
    'inviteAcceptWorkspaceFallback': 'the workspace',
    'inviteAcceptExistingData': 'Your current workspace has {goals} goal(s) and {events} event(s). Choose what happens to them when you join.',
    'inviteAcceptModeLabel': 'Existing data',
    'inviteAcceptModeMigrate': 'Move them to the new workspace',
    'inviteAcceptModeMigrateDesc': 'Your goals and events carry over to "{workspace}"',
    'inviteAcceptModeDelete': 'Delete them and join',
    'inviteAcceptModeDeleteDesc': 'Your current goals and events are deleted before you join. This cannot be undone',
    'inviteAcceptEmpty': 'Your current workspace is empty, so you will join as is.',
    'inviteAcceptSubmitBtn': 'Join workspace',
    'inviteAcceptCancelBtn': 'Cancel',
    'inviteAcceptDeleteConfirm': 'Delete {goals} goal(s) and {events} event(s), then join? This cannot be undone.',
    'inviteAcceptDeleteConfirmBtn': 'Delete and join',
    'inviteAcceptDone': 'You joined "{workspace}". Reloading…',
    'inviteAcceptErrorNotFound': 'This invitation link is not valid. Ask the person who invited you to resend it.',
    'inviteAcceptErrorAlreadyMember': 'You are already a member of this workspace',
    'backToLogin': 'Back to login',
    'updatePasswordDescription': 'Please enter your new password.',
    'newPassword': 'New password',
    'newPasswordConfirm': 'Confirm password',
    'newPasswordConfirmPlaceholder': 'Enter again',
    'passwordRuleHint': 'At least 12 characters. A few unrelated words strung together work well',
    'updatePasswordBtn': 'Update password',
    'updatePasswordSuccessMsg': 'Password updated. Please log in.',
    'signupPasswordError': 'Password must be at least 12 characters (up to 72 bytes)',
    'signupConfirmEmailSentTo': 'We sent an email to {email}. Follow the steps in it to finish signing up.',
    'confirmEmailDone': 'Your email address is confirmed',
    'confirmEmailEnterPassword': 'Log in with the password you chose when signing up to finish confirming your email address.',
    'confirmEmailInvalid': 'This confirmation link is invalid or expired. Sign up again with the same address to get a password reset email; resetting your password also confirms the address.',
    'passwordMismatch': 'Passwords do not match',
    // settings shell (#1473)
    'settingsGroupYou': 'You',
    'settingsGroupWorkspace': 'Workspace',
    'settingsNavProfile': 'Profile',
    'settingsNavAiPref': 'AI preferences',
    'settingsNavStyle': 'Writing style',
    'settingsNavMyConnections': 'Connections & auth',
    // account security (#3374)
    'mfaTitle': 'Two-step sign-in',
    'mfaNote': 'When you sign in, Zenmetry asks for a 6-digit code from an authenticator app (such as Google Authenticator) in addition to your password. A leaked password alone is then not enough to sign in.',
    'mfaStatusOn': 'On. The web app, the Chrome extension and AI connections ask for the 6-digit code at sign-in.',
    'mfaStatusOff': 'Not in use yet.',
    'mfaEnableBtn': 'Turn on two-step sign-in',
    'mfaSetupStep1': 'Scan the QR code below with the authenticator app on your phone.',
    'mfaSetupStep2': 'Enter the 6-digit code the app shows and press "Turn on".',
    'mfaQrAlt': 'QR code to scan with an authenticator app',
    'mfaSecretLabel': 'If you cannot scan the code, enter this key:',
    'mfaCodeLabel': '6-digit code',
    'mfaCodeHint': 'This account uses two-step sign-in. Enter the 6-digit code shown in your authenticator app.',
    'mfaActivateBtn': 'Turn on',
    'mfaActivateHint': 'Turning it on signs out your other devices and disconnects your AIs. Sign in again with the code next time you use them.',
    'mfaEnabledToast': 'Two-step sign-in is on',
    'mfaDisableBtn': 'Turn off two-step sign-in',
    'mfaDisableCodeLabel': 'Current 6-digit code, to confirm',
    'mfaDisableConfirm': 'Turn off',
    'mfaDisabledToast': 'Two-step sign-in is off',
    'aiConnectionsTitle': 'Connected AIs',
    'aiConnectionsNote': 'These AIs can read and write your Zenmetry. Disconnect any you do not recognize or no longer use. A disconnected AI cannot use Zenmetry until you connect it again.',
    'aiConnectionsEmpty': 'No AI is connected.',
    'aiConnectionsOrderNote': 'AI work goes to the AI highest in this list among those that declared a tool for it. Until you reorder, it goes to the AI that declared its tools most recently.',
    'aiConnectionOrder': 'No. {n}',
    'aiConnectionMoveUp': 'Move up',
    'aiConnectionMoveDown': 'Move down',
    'aiConnectionOrderSaved': 'Saved the AI order',
    'aiConversationPlaceHint': '"Where summaries and judgments go" is where an AI sends them when it acts on its own, such as at a set time. When you talk to it, it answers in that conversation.',
    'aiConnectionSessions': 'Manage connections ({n})',
    'aiConversationPlaceLabel': 'Where summaries and judgments go',
    'aiConversationPlaceConversation': 'Conversation with this AI',
    'aiConversationPlaceSlackDm': 'Slack DM to yourself',
    'aiConversationPlaceSaved': 'Saved where it goes',
    'aiConnectionConnectedAt': 'Connected {time}',
    'aiConnectionLastUsedAt': 'last used {time}',
    'aiConnectionRevoke': 'Disconnect',
    'aiConnectionRevokeConfirm': 'Disconnect',
    'aiConnectionRevokedToast': 'Disconnected {name}',
    'accountEndTitle': 'Stop using Zenmetry',
    'accountEndNote': 'You are signed out right away, and Gmail, Calendar, Slack and AI connections stop. After 14 days your goals and other data, and your account, are deleted. Within 14 days you can cancel by contacting support@zenmetry.net.',
    'accountEndBtn': 'Stop using Zenmetry',
    'accountEndEmailLabel': 'To confirm, enter the email address you sign in with',
    'accountEndConfirm': 'Stop using Zenmetry',
    'accountEndDoneToast': 'Your use has ended. Your data will be deleted in 14 days.',
    'settingsNavAdvanced': 'Advanced',
    'settingsNavMembers': 'Members & invites',
    'settingsNavIntegrationPolicy': 'Integration policy',
    'settingsNavSyncRules': 'Sync rules',
    'settingsBadgePersonal': 'Personal',
    'settingsBadgePersonalHint': 'Not shared with other members',
    'settingsBadgeWorkspaceShared': 'Workspace shared',
    'settingsBadgeWorkspaceSharedHint': 'Shared with all workspace members',
    'settingsCrumb': '/ Settings',
    'settingsTitle': 'Settings',
    'settingsMenuOpen': 'Menu',
    'settingsMenuTitle': 'Settings menu',
    'settingsSaveRegionLabel': 'Save profile settings',
    'settingsUnsavedChanges': 'You have unsaved changes',
    'settingsSaveScope': 'Saves Profile, AI preferences, and Advanced settings together. Work left to AI is saved as you choose.',
    'settingsSaveProfileChanges': 'Save profile and preferences',
    'settingsDiscardChanges': 'Discard changes',
    'settingsChangesDiscarded': 'Changes discarded',
    'settingsDiscardReloadError': 'Could not load the latest settings. Your changes are still preserved.',
    'settingsSaving': 'Saving',
    'settingsProfileSaved': 'Profile settings saved',
    'settingsProfileSavePartialError': 'Some changes may not have been saved. Retry to save all settings again.',
    'settingsUnsavedExitConfirm': 'You have unsaved profile settings. Discard them and close Settings?',
    'settingsUnsavedWorkspaceExitConfirm': 'You have unsaved workspace settings. Discard them and close Settings?',
    'settingsSectionPlaceholder': 'This section is not available yet',
    'settingsMembersDescription': 'Invite members, change roles, and remove members from workspace management.',
    'settingsMembersAction': 'Manage members',
    'settingsYouGroupNote': 'These settings are personal to you. They are not shared with other workspace members (except your display name).',
    'settingsWorkspaceGroupNote': 'This workspace\'s goals, events, and tasks are visible to all members. Personal settings and connection credentials are not shared.',
    'myConnectionsNote': 'Manage ingest on/off, share scope, and ingest conditions for each connected account.',
    'myConnectionsLoading': 'Loading…',
    'myConnectionsEmpty': 'No accounts connected yet.',
    'myConnectionsConnectAction': 'Connect an account',
    'myConnectionsConnectGoogleAction': 'Connect Google',
    'myConnectionsConnectSlackAction': 'Connect Slack',
    'myConnectionsConnectedAt': 'Connected {date}',
    'myConnectionsStatusActive': 'Authenticated',
    'myConnectionsStatusRevoked': 'Disconnected (ingested data is kept)',
    'myConnectionsGroupGoogle': 'Google account',
    'myConnectionsGroupGoogleNote': 'Gmail and Calendar connect through the same Google account and are disconnected together.',
    'myConnectionsPurgeRevokedAction': 'Delete data too',
    'myConnectionsReconnectAction': 'Reconnect',
    'myConnectionsPurgeRevokedConfirmMessage': 'Delete the source data ingested from this connection? Goals and tasks already created are kept.',
    'myConnectionsPurgeRevokedConfirmOk': 'Delete',
    'myConnectionsPurgeRevokedSuccess': 'Ingested data deleted',
    'myConnectionsPurgeRevokedError': 'Could not delete the data',
    'myConnectionsStatusError': 'Connection needs attention',
    'myConnectionsDisclosureHint': 'Press Enter or Space to toggle connection details',
    'myConnectionsDisconnectAction': 'Disconnect',
    'myConnectionsPurgeHint': 'You can choose to delete ingested data when disconnecting',
    'myConnectionsConfirmMessage': 'Disconnect this account?',
    'myConnectionsConfirmGoogleMessage': 'Disconnect this Google account (Gmail and Calendar)?',
    'myConnectionsConfirmPurgeLabel': 'Also delete ingested data',
    'myConnectionsConfirmPurgeHint': 'Deletes source data ingested from this connection. Goals and tasks already created remain saved.',
    'myConnectionsConfirmCancel': 'Cancel',
    'myConnectionsConfirmOk': 'Disconnect',
    'myConnectionsLoadError': 'Failed to load connected accounts',
    'myConnectionsConnectError': 'Failed to start the connection',
    'myConnectionsDisconnectSuccess': 'Account disconnected',
    'myConnectionsDisconnectError': 'Failed to disconnect',
    'connectionRowIngestLabel': 'Ingest',
    'connectionRowCalendarIngestLabel': 'Calendar ingest for this Google account',
    'connectionRowIngestOnReadback': 'Ingest on',
    'connectionRowIngestOffReadback': 'Ingest off',
    'connectionRowCalendarIngestOnReadback': 'Calendar ingest on for this Google account',
    'connectionRowCalendarIngestOffReadback': 'Calendar ingest off for this Google account',
    'connectionRowVisibilityLabel': 'Share scope',
    'connectionRowVisibilityPrivate': 'Private',
    'connectionRowVisibilityShared': 'Workspace shared',
    'connectionRowShareScopeReadback': 'Share scope: {scope}',
    'connectionRowGoogleDetailDescription': 'You can set account-level ingest and share scope.',
    'connectionRowSlackDetailDescription': 'You can set Slack ingest and share scope. Detailed ingest conditions cannot currently be changed.',
    'connectionRowFilterHeading': 'Ingest conditions',
    'connectionRowFilterUnavailableDescription': 'Detailed ingest conditions cannot currently be changed.',
    'connectionFilterLoading': 'Loading setting options from Google…',
    'connectionFilterDegraded': 'Google is unavailable. Saved conditions are shown read-only.',
    'connectionFilterSave': 'Save ingest conditions',
    'gmailGlobalFilterSave': 'Save categories and addresses',
    'gmailLabelFilterSave': 'Save labels for this connection',
    'connectionFilterSaveSuccess': 'Ingest conditions updated',
    'connectionFilterSaveError': 'Failed to update ingest conditions. Saved settings were reloaded.',
    'gmailFilterCategories': 'Categories to ingest',
    'gmailFilterExcludedSenders': 'Excluded senders (one per line)',
    'gmailFilterExcludedRecipients': 'Excluded recipients (one per line)',
    'gmailFilterLabels': 'Extra labels to exclude inside Inbox',
    'gmailFilterLabelsHint': 'Zenmetry starts from Gmail messages in Inbox. Labels that usually stay outside Inbox, such as Spam or Trash, normally do not need to be excluded here.',
    'gmailCategory_CATEGORY_PERSONAL': 'Primary',
    'gmailCategory_CATEGORY_SOCIAL': 'Social',
    'gmailCategory_CATEGORY_PROMOTIONS': 'Promotions',
    'gmailCategory_CATEGORY_UPDATES': 'Updates',
    'gmailCategory_CATEGORY_FORUMS': 'Forums',
    'calendarModeOff': 'Do not ingest',
    'calendarModeEventsOnly': 'Reference as events',
    'calendarModeGoals': 'Link to goals',
    'connectionRowRevokedDescription': 'This connection is disconnected. Reconnect it to change its settings.',
    'connectionRowErrorDescription': 'Settings cannot be changed because the connection could not be confirmed. Try again later or reconnect the account.',
    'connectionRowIntegrationNotAllowedDescription': 'This workspace does not allow ingest from this integration. Ask a workspace administrator if you need the setting changed.',
    'connectionRowReadOnlyHint': 'Settings for this connection cannot be changed yet',
    'connectionRowIntegrationNotAllowedHint': 'Not allowed by this workspace',
    'connectionRowIngestAriaLabel': 'Toggle ingest for {provider}',
    'myConnectionsIngestOnSuccess': 'Ingest enabled',
    'myConnectionsIngestOffSuccess': 'Ingest disabled',
    'myConnectionsIngestUpdateError': 'Failed to update ingest setting',
    'myConnectionsVisibilitySuccess': 'Share scope updated',
    'myConnectionsVisibilityError': 'Failed to update share scope',
    'styleProfileNote': 'Zenmetry uses writing style learned from past Gmail and Slack messages when drafting email and Slack replies. If style cannot be learned, it uses the writing-style settings in Advanced.',
    'styleProfileLoading': 'Loading…',
    'styleProfileEmpty': 'Not analyzed yet. Run the style-analyzer skill in Claude to populate this section.',
    'styleProfileNotAnalyzedAlert': 'Not analyzed yet. Ask Claude to "run style-analyzer" and your writing style profile will appear here.',
    'styleProfileEmptyTitle': 'Writing style profile is not created yet',
    'styleProfileEmptyDescription': 'Click to copy the message for Claude and open Claude. After analysis, future drafts can reference your writing style.',
    'styleProfileCopyPromptAction': 'Analyze style in Claude',
    'styleProfileAnalyzerPrompt': 'Please run Zenmetry style-analyzer and create my writing style profile from past Gmail and Slack messages.',
    'styleProfileResultLabel': 'Analysis result',
    'styleProfileAnalyzedAt': 'Last analyzed: {date}',
    'styleProfileToneAxis': 'Tone',
    'styleProfileSentenceLengthAxis': 'Sentence length',
    'styleProfileFormalityAxis': 'Formality',
    'styleProfileReanalyzeInfo': 'Use the same Claude request when you want to update this profile.',
    'styleProfileLoadError': 'Failed to load writing style profile',
    'integrationPolicyNote': 'Manage which integrations this workspace allows.',
    'integrationPolicyLoading': 'Loading…',
    'integrationPolicyLoadError': 'Failed to load integration policy',
    'integrationPolicySaveSuccess': 'Integration policy updated',
    'integrationPolicySaveError': 'Failed to update integration policy',
    'integrationPolicyRowSub': 'Automatically detect goals and tasks from {provider}',
    'integrationPolicyAllowLabel': 'Ingest permission',
    'integrationPolicyAllowAriaLabel': 'Allow {provider} integration',
    'integrationPolicyMemberReadOnlyHint': 'Only the workspace owner can change this',
    'integrationPolicyMemberNote': 'Member invitations and role changes are managed by the workspace owner. Integration policy changes are owner-only as well.',
    'integrationPolicyCrossLinkNote': 'Per-account ingest ON/OFF, share scope, and disconnecting are managed from "You > Connections & auth".',
    'integrationPolicyGhostGoogleCalendar': 'Google Calendar — coming soon',
    'integrationPolicyGhostSlack': 'Slack — coming soon',
    'integrationMemberStatusConnected': 'Connected',
    'integrationMemberStatusNotConnected': 'Not connected',
    'integrationMemberStatusPaused': 'Paused',
    'integrationMemberStatusReauth': 'Reconnect required',
    'integrationMemberStatusHeading': 'Member connection status',
    'integrationMemberVisibilityMixed': 'Varies by connection',
    // workspace panel (#1239)
    'workspaceMenuItem': 'Workspace',
    'workspaceUnavailable': 'Workspace feature is not available',
    'workspaceTitle': 'Workspace',
    'workspaceSharedNotice': 'Goals and events in this workspace, including existing ones, are shared with all members.',
    'workspaceMemberCount': '{count} member(s)',
    'workspaceMembersHeading': 'Members',
    'workspaceRoleOwner': 'Owner',
    'workspaceRoleAdmin': 'Admin',
    'workspaceRoleMember': 'Member',
    'workspaceRoleGuest': 'Guest',
    'workspaceMemberFallbackName': '(No name set)',
    'workspaceChangeRole': 'Change role',
    'workspaceRemoveMember': 'Remove',
    'workspaceRemoveMemberConfirm': 'Remove {name} from this workspace? The Gmail, Calendar, and Slack connections they made in this workspace will also be disconnected, and importing from them will stop. Goals and events already imported stay. This cannot be undone.',
    'workspaceRemoveMemberConfirmBtn': 'Remove',
    'workspaceRemoveMemberCancelBtn': 'Cancel',
    'workspaceRemoveMemberSuccess': 'Member removed',
    'workspaceRoleUpdateSuccess': 'Role updated',
    'workspaceInvitationsHeading': 'Pending invitations',
    'workspaceInviteEmailPlaceholder': 'Email address',
    'workspaceInviteRoleLabel': 'Role to invite',
    'workspaceInviteSubmitBtn': 'Send invite',
    'workspaceInviteResendBtn': 'Resend',
    'workspaceInviteRevokeBtn': 'Revoke',
    'workspaceInviteRevokeConfirm': 'Revoke the invitation sent to {email}?',
    'workspaceInviteRevokeConfirmBtn': 'Revoke',
    'workspaceInviteCreateSuccess': 'Invitation email sent',
    'workspaceInviteResendSuccess': 'Invitation email resent',
    'workspaceInviteDeliveryFailed': 'The invitation was created, but the email could not be sent. Try "Resend" in a moment.',
    'workspaceInviteResendDeliveryFailed': 'The invitation was updated, but the email could not be sent. Try "Resend" again in a moment.',
    'workspaceInviteRevokeSuccess': 'Invitation revoked',
    'workspaceInviteStatusPending': 'Pending',
    'workspaceInviteStatusConsumed': 'Joined',
    'workspaceInviteStatusRevoked': 'Revoked',
    'workspaceInviteStatusExpired': 'Expired',
    'workspaceInviteStatusUnknown': 'Unknown',
    'workspaceInviteExpiresAt': 'Expires: {date}',
    'workspaceInviteMailNote': 'The person you invite receives an email with a link to join.',
    'workspaceNoMembers': 'No members',
    'workspaceNoInvitations': 'No pending invitations',
    'workspaceLoading': 'Loading...',
    'workspaceErrorMembershipMissing': 'You are not a member of this workspace',
    'workspaceErrorMultipleMemberships': 'Could not determine your workspace state',
    'workspaceErrorNotFound': 'Workspace not found',
    'workspaceErrorAdminForbidden': 'You do not have permission to do this',
    'workspaceErrorMemberNotFound': 'That member could not be found',
    'workspaceErrorLastOwnerProtected': 'The last owner cannot be changed or removed',
    'workspaceErrorInvalidRole': 'That role cannot be selected',
    'workspaceErrorInvalidEmail': 'Please enter a valid email address',
    'workspaceErrorInvalidInvitation': 'Invitation details are invalid',
    'workspaceErrorInvitationNotFound': 'Invitation not found',
    'workspaceErrorInvitationConflict': 'The invitation state has changed. Please reload.',
    'workspaceErrorInviteTargetConflict': 'This email already belongs to a workspace that has other members',
    'workspaceErrorInviteTargetAmbiguous': 'Could not resolve a single account for this email',
    'workspaceErrorInvitationRevoked': 'This invitation was revoked',
    'workspaceErrorInvitationConsumed': 'This invitation was already used',
    'workspaceErrorInvitationExpired': 'This invitation has expired',
    'workspaceErrorInvitationEmailMismatch': 'This invitation was sent to a different email address. Log in with the invited address.',
    'workspaceErrorActiveMembershipConflict': 'You already belong to a workspace with other members, so this invitation cannot be accepted',
    'workspaceErrorMigrationConflict': 'Moving your goals and events ran into a conflict. Join by deleting them, or contact support.',
    'workspaceErrorInvalidAcceptanceMode': 'Choose how to join',
    'workspaceErrorGeneric': 'Something went wrong. Please try again later.',
    'profilePersonalSourceNotice': 'Connected accounts and notification settings are personal to you. Only synced goals and events are shared with the workspace.',
    // workspace sync rules (#1473 C2/C3; persistence only)
    'workspaceSyncRulesNote': 'Manage the calendar sync window and the default for goals without a deadline at the workspace level. Choose which calendars to include in your personal connection settings.',
    'workspaceSyncRulesLoading': 'Loading sync rules…',
    'workspaceSyncRulesLoadError': 'Could not load sync rules',
    'workspaceSyncRulesGenericError': 'Could not save sync rules. Check the values and try again.',
    'workspaceSyncRulesOwnerOnlyNote': 'Only the workspace owner can change shared settings. You are viewing the current values read-only.',
    'workspaceSyncRulesCalendarHeading': 'Calendar sync',
    'workspaceSyncRulesCalendarDescription': 'Set the sync window and how all-day events are handled for this workspace.',
    'workspaceSyncRulesWindowLabel': 'Sync window',
    'workspaceSyncRulesWindowHint': 'Choose how many days ahead of today to sync calendar events.',
    'workspaceSyncRulesDays': 'days',
    'workspaceSyncRulesExcludeAllDayLabel': 'Do not sync all-day events',
    'workspaceSyncRulesExcludeAllDayHint': 'When enabled, all-day events are excluded from workspace sync.',
    'workspaceSyncRulesExcludeAllDayOn': 'Excluded',
    'workspaceSyncRulesExcludeAllDayOff': 'Included',
    'workspaceSyncRulesCalendarConnectionLink': 'Choose which calendars to include under “You > Connections & auth”.',
    'workspaceSyncRulesGoalHeading': 'Goals without a deadline',
    'workspaceSyncRulesGoalDescription': 'Choose the default for goals without a deadline. This setting is currently persisted and displayed only; it is not used during goal generation.',
    'workspaceSyncRulesNoDueDateLabel': 'Handling for goals without a deadline',
    'workspaceSyncRulesNoDueDateHint': 'This setting is persistence-only for now. Goal-generation behavior will be handled separately.',
    'workspaceSyncRulesNoDueDate_keep_empty': 'Keep the deadline empty',
    'workspaceSyncRulesNoDueDate_propose_estimate': 'Propose a deadline estimate',
    'workspaceSyncRulesNoDueDate_create_decide_task': 'Create a task to decide the deadline',
    'workspaceSyncRulesSave': 'Save shared settings',
    'workspaceSyncRulesSaving': 'Saving',
    'workspaceSyncRulesSaveSuccess': 'Shared settings saved',
    'workspaceSyncRulesReadbackError': 'Saved, but the latest value could not be confirmed. Reload to check again.',
    'workspaceSyncRulesReload': 'Reload latest values',
    'workspaceSyncRulesUnsaved': 'You have unsaved changes',
    'workspaceSyncRulesInvalidWindow': 'The sync window must be a positive integer',
  }
};

export let currentLang = localStorage.getItem('zenmetry_lang') || (navigator.language.startsWith('en') ? 'en' : 'ja');

export function setCurrentLang(lang) {
  currentLang = lang;
}

export function t(key, params = {}) {
  const val = LOCALES[currentLang]?.[key] ?? LOCALES['ja'][key] ?? key;
  if (Array.isArray(val)) return val;
  return String(val).replace(/\{(\w+)\}/g, (_, k) => params[k] ?? '');
}

export function applyLang() {
  document.querySelectorAll('[data-i18n]').forEach(el => {
    el.textContent = t((el as HTMLElement).dataset.i18n) as string;
  });
  document.querySelectorAll('[data-i18n-placeholder]').forEach(el => {
    (el as HTMLInputElement).placeholder = t((el as HTMLElement).dataset.i18nPlaceholder) as string;
  });
  document.documentElement.lang = currentLang;
  const toggleBtn = document.getElementById('langToggleBtn');
  if (toggleBtn) toggleBtn.textContent = t('langToggleLabel') as string;
  if (typeof window.renderAgreeTermsText === 'function') window.renderAgreeTermsText();
  if (typeof window.updatePasswordHints === 'function') window.updatePasswordHints();
  document.dispatchEvent(new CustomEvent('zen-lang-change'));
}

export function toggleLang() {
  currentLang = currentLang === 'ja' ? 'en' : 'ja';
  localStorage.setItem('zenmetry_lang', currentLang);
  applyLang();
}

export { LOCALES };

// Apply language on initial load
applyLang();
